/* U-VITA Life Stage theme v16: dependency-free behaviours. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {} };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = theme.moneyFormat || '₹{{amount_no_decimals}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var n = Number(cents) / 100;
    var dec = m && m[1].indexOf('no_decimals') > -1 ? 0 : 2;
    var val = n.toLocaleString('en-IN', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-in');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-in'); }, 3200);
  }
  window.uvToast = toast;

  /* ---------- Reveal on scroll (only items below the first screen start hidden) ---------- */
  function initReveal() {
    if (reduced || document.documentElement.classList.contains('no-reveal') || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.remove('is-pending'); e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var vh = window.innerHeight;
    $$('[data-reveal]').forEach(function (el) {
      if (el.getBoundingClientRect().top > vh * 0.92) { el.classList.add('is-pending'); io.observe(el); }
      else el.classList.add('is-in');
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters() {
    var els = $$('[data-count]');
    if (!els.length || reduced || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = parseFloat(el.getAttribute('data-count')), suffix = el.getAttribute('data-suffix') || '', start = performance.now(), dur = 1400;
        (function tick(t) {
          var p = Math.min(1, (t - start) / dur), v = Math.round(end * (1 - Math.pow(1 - p, 3)));
          el.textContent = v + suffix;
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight) io.observe(el); });
  }

  /* ---------- Generic in-view class (comparison checks etc.) ---------- */
  function initInView() {
    var els = $$('[data-inview]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Announcement rotation ---------- */
  function initAnnouncement() {
    $$('[data-announcement]').forEach(function (bar) {
      if (bar._annc) return; bar._annc = true;
      var items = $$('.announcement__item', bar), floating = bar.getAttribute('data-style') === 'floating';
      var every = (parseFloat(bar.getAttribute('data-speed')) || 4.5) * 1000, i = 0, timer = null, paused = false;
      var ring = $('.announcement__ring circle', bar);
      bar.style.setProperty('--annc-speed', every / 1000 + 's');
      function restartRing() { if (!ring) return; ring.style.animation = 'none'; void ring.getBoundingClientRect(); ring.style.animation = ''; }
      function next() {
        if (document.hidden || paused || items.length < 2) return;
        var cur = items[i]; cur.classList.remove('is-active'); cur.classList.add('was-active');
        setTimeout(function () { cur.classList.remove('was-active'); }, 650);
        i = (i + 1) % items.length; items[i].classList.add('is-active');
        restartRing();
      }
      function start() { if (items.length > 1 && !timer) timer = setInterval(next, every); }
      if (!floating) { start(); return; }
      var key = 'uv-annc-closed', design = window.Shopify && window.Shopify.designMode, closed = false;
      try { closed = sessionStorage.getItem(key) === '1'; } catch (e) { closed = false; }
      if (closed && !design) return;
      var miniTimer = null;
      function scheduleMini() { clearTimeout(miniTimer); miniTimer = setTimeout(mini, Math.max(2, items.length) * every + 600); }
      function mini() {
        if (paused) { scheduleMini(); return; }
        bar.classList.add('is-gone');
        setTimeout(function () { bar.classList.add('is-mini'); bar.classList.remove('is-gone'); }, 520);
      }
      function expand() { bar.classList.add('is-gone'); setTimeout(function () { bar.classList.remove('is-mini', 'is-gone'); restartRing(); scheduleMini(); }, 380); }
      function show() { bar.hidden = false; void bar.offsetWidth; bar.classList.add('is-shown'); restartRing(); start(); scheduleMini(); }
      on($('.announcement__badge', bar), 'click', function () { if (bar.classList.contains('is-mini')) expand(); });
      on(bar, 'click', function (e) { if (bar.classList.contains('is-mini') && !e.target.closest('[data-announcement-close]')) { e.preventDefault(); expand(); } });
      var delay = design ? 0 : (parseFloat(bar.getAttribute('data-delay')) || 1.5) * 1000;
      if (!design && (window.matchMedia('(max-width: 749px)').matches || document.querySelector('[data-hx]'))) {
        /* On phones and below the home banners, wait until the shopper scrolls past the first screen so the note never covers the banner */
        var onScroll = function () { if (window.scrollY > window.innerHeight * .6) { window.removeEventListener('scroll', onScroll); setTimeout(show, 300); } };
        window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      } else setTimeout(show, delay);
      on(bar, 'mouseenter', function () { paused = true; }); on(bar, 'mouseleave', function () { paused = false; });
      on(bar, 'focusin', function () { paused = true; }); on(bar, 'focusout', function () { paused = false; });
      on($('[data-announcement-close]', bar), 'click', function () {
        bar.classList.remove('is-shown'); bar.classList.add('is-gone'); clearInterval(timer); clearTimeout(miniTimer);
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        setTimeout(function () { bar.hidden = true; }, 700);
      });
    });
  }

  /* ---------- Header: scrolled state, hide on scroll down ---------- */
  function initHeader() {
    var header = $('[data-header]'); if (!header) return;
    var last = window.scrollY, ticking = false, canHide = header.getAttribute('data-hide-on-scroll') !== 'false' && header.getAttribute('data-sticky') !== 'false';
    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      var open = header.querySelector('.main-nav__item.is-open');
      if (canHide && !open && y > 320 && y > last + 4) header.classList.add('is-hidden');
      else if (y < last - 4 || y < 200) header.classList.remove('is-hidden');
      last = y; ticking = false;
    }
    update();
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
  }

  /* ---------- Mega menu ---------- */
  function initMega() {
    var items = $$('.main-nav__item[data-mega]');
    items.forEach(function (item) {
      var btn = $('.main-nav__link', item), timer;
      function open() { clearTimeout(timer); items.forEach(function (o) { if (o !== item) close.call(o); }); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      function close() { var it = this && this.classList ? this : item; it.classList.remove('is-open'); var b = $('.main-nav__link', it); if (b) b.setAttribute('aria-expanded', 'false'); }
      item.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) open(); });
      item.addEventListener('mouseleave', function () { timer = setTimeout(close, 160); });
      on(btn, 'click', function (e) { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      item._close = close;
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') items.forEach(function (it) { it._close && it._close(); }); });
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]'); if (!menu) return;
    var lastFocus;
    function open() { lastFocus = document.activeElement; menu.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; var c = $('[data-menu-close]', menu); if (c) setTimeout(function () { c.focus(); }, 60); }
    function close() { menu.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
    $$('[data-menu-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-menu-close]', menu).forEach(function (b) { on(b, 'click', close); });
    on($('.mobile-menu__scrim', menu), 'click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
    theme.closeMobileMenu = close;
  }

  /* ---------- Hero slider ---------- */
  function initHero() {
    $$('[data-hero]').forEach(function (hero) {
      var slides = $$('.hero__slide', hero), dots = $$('.hero__dot', hero); if (slides.length < 2) return;
      var delay = parseFloat(hero.getAttribute('data-delay') || '6') * 1000, i = 0, timer, paused = hero.getAttribute('data-autoplay') === 'false';
      hero.style.setProperty('--hero-delay', delay / 1000 + 's');
      function go(n) {
        slides[i].classList.remove('is-active'); slides[i].classList.add('was-active');
        dots.forEach(function (d, k) { d.classList.toggle('is-done', k < n); d.classList.remove('is-active'); d.setAttribute('aria-current', 'false'); });
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active', 'was-active');
        if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
        schedule();
      }
      function schedule() { clearTimeout(timer); if (!reduced && !paused) timer = setTimeout(function () { go(i + 1); }, delay); }
      dots.forEach(function (d, k) { on(d, 'click', function () { go(k); }); });
      on($('[data-hero-prev]', hero), 'click', function () { go(i - 1); });
      on($('[data-hero-next]', hero), 'click', function () { go(i + 1); });
      on(hero, 'mouseenter', function () { paused = true; hero.classList.add('is-paused'); clearTimeout(timer); });
      on(hero, 'mouseleave', function () { if (hero.getAttribute('data-autoplay') === 'false') return; paused = false; hero.classList.remove('is-paused'); schedule(); });
      var x0 = null;
      on(hero, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      on(hero, 'touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
      if (dots[0] && !reduced) dots[0].classList.add('is-active');
      schedule();
    });
  }

  /* ---------- Rails (scroll-snap carousels) ---------- */
  function initRails() {
    $$('[data-rail]').forEach(function (rail) {
      if (rail.__uvRail) return; rail.__uvRail = true;
      var id = rail.id, bar = id && $('[data-rail-progress="' + id + '"] span');
      function step() { var c = rail.firstElementChild; var gap = parseFloat(getComputedStyle(rail).columnGap) || 16; return c ? c.getBoundingClientRect().width + gap : 300; }
      $$('[data-rail-prev="' + id + '"]').forEach(function (b) { on(b, 'click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
      $$('[data-rail-next="' + id + '"]').forEach(function (b) { on(b, 'click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); }); });
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        if (bar) { var w = Math.max(.12, rail.clientWidth / rail.scrollWidth); bar.style.width = (w * 100) + '%'; bar.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 - w) / w) * 100 : 0) + '%)'; }
        $$('[data-rail-prev="' + id + '"]').forEach(function (b) { b.disabled = rail.scrollLeft < 4; });
        $$('[data-rail-next="' + id + '"]').forEach(function (b) { b.disabled = rail.scrollLeft > max - 4; });
      }
      on(rail, 'scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update); update();
      // drag to scroll with a mouse
      var down = false, sx = 0, sl = 0, moved = false;
      on(rail, 'mousedown', function (e) { if (e.button !== 0 || e.target.closest('button, input, select, label')) return; down = true; moved = false; sx = e.pageX; sl = rail.scrollLeft; });
      window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 6) { moved = true; rail.classList.add('is-dragging'); } rail.scrollLeft = sl - dx; });
      window.addEventListener('mouseup', function () { if (!down) return; down = false; setTimeout(function () { rail.classList.remove('is-dragging'); }, 0); });
      on(rail, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- Tabs (segmented, ladder) ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (list) {
      var tabs = $$('[role="tab"]', list);
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var sel = t === tab; t.setAttribute('aria-selected', sel ? 'true' : 'false'); t.tabIndex = sel ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls')); if (!panel) return;
          if (sel) { panel.hidden = false; panel.classList.remove('is-entering'); void panel.offsetWidth; panel.classList.add('is-entering'); } else panel.hidden = true;
        });
        if (focus) tab.focus();
        list.dispatchEvent(new CustomEvent('uv:tabchange', { detail: { tab: tab }, bubbles: true }));
        var tint = tab.getAttribute('data-tint-target');
        if (tint) { var t2 = document.getElementById(tint); if (t2) t2.setAttribute('style', tab.getAttribute('data-vars') || ''); }
      }
      tabs.forEach(function (tab, i) {
        on(tab, 'click', function () { select(tab); });
        on(tab, 'keydown', function (e) {
          var k = e.key, d = (k === 'ArrowRight' || k === 'ArrowDown') ? 1 : (k === 'ArrowLeft' || k === 'ArrowUp') ? -1 : 0;
          if (!d) return; e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length], true);
        });
      });
    });
  }

  /* ---------- Life-stage ladder: the climber moves to the selected rung ---------- */
  function initLadder() {
    $$('[data-ladder]').forEach(function (root) {
      var frame = $('.ladder__frame', root), climber = $('[data-ladder-climber]', root);
      if (!frame || !climber) return;
      function place(tab) {
        tab = tab || $('[role="tab"][aria-selected="true"]', frame); if (!tab) return;
        var fr = frame.getBoundingClientRect(), r = tab.getBoundingClientRect();
        if (!r.height) return;
        climber.style.setProperty('--climb', (r.top - fr.top + r.height / 2) + 'px');
      }
      var tabs = $$('[role="tab"]', frame);
      // Start on the bottom rung and climb once the ladder comes into view.
      if (tabs[0]) place(tabs[0]);
      if (reduced || !('IntersectionObserver' in window)) { place(); }
      else {
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return; io.disconnect();
          setTimeout(function () { place(); }, 650);
        }, { threshold: 0.35 });
        io.observe(frame);
      }
      on(frame, 'uv:tabchange', function (e) { place(e.detail && e.detail.tab); });
      var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { place(); }, 120); });
    });
  }

  /* ---------- Nutrition gap: the pack pours into each glass ---------- */
  function initGap() {
    $$('[data-gap]').forEach(function (root) {
      if (root._gap) return; root._gap = true;
      var toggle = $('[data-gap-toggle]', root), seen = false, run = 0;
      var auto = root.getAttribute('data-autoplay') !== 'false';
      var k = parseFloat(getComputedStyle(root).getPropertyValue('--pour')) || 1;
      var cv = document.createElement('canvas'); cv.className = 'gap__fx'; cv.setAttribute('aria-hidden', 'true'); root.appendChild(cv);
      var ctx = cv.getContext ? cv.getContext('2d') : null, parts = [], drops = [], raf = 0, dpr = 1, W = 0, H = 0;
      /* Where the opening sits on each pack, as a share of the pack image (top of the jar or bottle once the cap is off) */
      var GEO = { drop: { mouth: .158, lip: .40, ang: 112 }, tablet: { mouth: .268, lip: .2, ang: 122 } };
      var queue = [], busy = false, idle = 0, cur = null;
      function size() { var r = root.getBoundingClientRect(); dpr = Math.min(2, window.devicePixelRatio || 1); W = r.width; H = r.height; cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
      size(); on(window, 'resize', function () { size(); });
      function rel(el) { var r = el.getBoundingClientRect(), rr = root.getBoundingClientRect(); return { x: r.left - rr.left, y: r.top - rr.top, w: r.width, h: r.height }; }
      function panel() { return $$('[data-gap-panel]', root).filter(function (p) { return !p.hidden; })[0]; }
      function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
      /* colours: '#rrggbb' or 'rgb(...)' mixed toward white (w > 0) or black (w < 0) */
      function rgb(c) {
        c = (c || '').trim(); var m;
        if ((m = c.match(/^#([0-9a-f]{6})$/i))) { var n = parseInt(m[1], 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
        if ((m = c.match(/^#([0-9a-f]{3})$/i))) { return m[1].split('').map(function (h) { return parseInt(h + h, 16); }); }
        if ((m = c.match(/rgba?\(([^)]+)\)/))) { return m[1].split(/[ ,\/]+/).slice(0, 3).map(Number); }
        return [45, 106, 79];
      }
      function mix(c, w) { var a = rgb(c), t = w > 0 ? 255 : 0, f = Math.abs(w); return 'rgb(' + a.map(function (v) { return Math.round(v + (t - v) * f); }).join(',') + ')'; }
      function colours(glass, tablet) {
        var cs = getComputedStyle(glass), fill = (cs.getPropertyValue('--fill-c') || '').trim(), label = (cs.getPropertyValue('--p-label') || '#2D6A4F').trim();
        if (tablet) return { body: label, hi: mix(label, .45), edge: mix(label, -.25), splash: mix(label, .3) };
        var c = fill || label; return { body: c, hi: mix(c, .35), lo: mix(c, -.18), splash: mix(c, .2) };
      }
      function setCount(p, bump) {
        var n = $$('.glass.is-filled', p).length, b = $('[data-gap-count]', p); if (!b) return;
        if (b.textContent !== String(n)) { b.textContent = n; if (bump && !reduced) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); } }
        var all = $$('[data-gap-glass]', p), on_ = all.length && all.every(function (g) { return g.classList.contains('is-filled') || g.classList.contains('is-queued') || g.classList.contains('is-pouring'); });
        toggle.setAttribute('aria-pressed', on_ ? 'true' : 'false');
      }
      function packFor(p, glass) { var packs = $$('[data-gap-pack]', p); return packs[(parseInt(glass.getAttribute('data-pack'), 10) || 1) - 1] || packs[0]; }
      function kindOf(pk) { return pk.getAttribute('data-particle') === 'tablet' ? 'tablet' : 'drop'; }
      function lvlOf(g) { return parseFloat(g.style.getPropertyValue('--lvl')) || 0; }
      /* Particles: a soft stream of powder in the colour of the drink, or tablets in the pack colour that tumble in and fizz */
      function loop() {
        raf = 0; if (!ctx) return;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, W, H);
        var now = performance.now();
        for (var n = parts.length - 1; n >= 0; n--) {
          var q = parts[n], dt = Math.min(34, now - q.t) / 16.67; q.t = now;
          q.vy += (q.tab ? .36 : .28) * dt; q.vx *= Math.pow(.97, dt); q.x += q.vx * dt; q.y += q.vy * dt; q.r += q.vr * dt;
          var fy = q.floor();
          if (q.y >= fy) {
            parts.splice(n, 1);
            if (q.tab) {
              for (var s = 0; s < 5; s++) drops.push({ x: q.x, y: fy, vx: (Math.random() - .5) * 2.4, vy: -1 - Math.random() * 2, life: 1, c: q.col.splash, t: now, rad: 1.2 + Math.random() * 1.5, g: .26 });
              for (var f = 0; f < 22; f++) drops.push({ x: q.x + (Math.random() - .5) * 22, y: fy + 6 + Math.random() * 40, vx: (Math.random() - .5) * .3, vy: -.25 - Math.random() * .7, life: 1 + Math.random() * .8, c: 'rgba(255,255,255,.85)', t: now, rad: .8 + Math.random() * 1.6, g: -.004, fizz: true, top: fy });
            } else if (Math.random() < .1) drops.push({ x: q.x, y: fy, vx: (Math.random() - .5) * 1.3, vy: -.5 - Math.random(), life: .7, c: q.c, t: now, rad: 1 + Math.random(), g: .24 });
            continue;
          }
          ctx.save(); ctx.translate(q.x, q.y); ctx.rotate(q.r); ctx.globalAlpha = q.a;
          if (q.tab) {
            var w = 22, h = 11.5; ctx.shadowColor = 'rgba(18,70,63,.28)'; ctx.shadowBlur = 4; ctx.shadowOffsetY = 1.5;
            var gr = ctx.createLinearGradient(0, -h / 2, 0, h / 2); gr.addColorStop(0, q.col.hi); gr.addColorStop(1, q.col.body);
            ctx.fillStyle = gr; ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(-w / 2, -h / 2, w, h, h / 2); else ctx.rect(-w / 2, -h / 2, w, h); ctx.fill();
            ctx.shadowColor = 'transparent'; ctx.strokeStyle = q.col.edge; ctx.lineWidth = 1; ctx.stroke();
            ctx.strokeStyle = 'rgba(255,255,255,.55)'; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(0, -h / 2 + 2); ctx.lineTo(0, h / 2 - 2); ctx.stroke();
          } else { ctx.fillStyle = q.c; ctx.beginPath(); ctx.arc(0, 0, q.size, 0, 6.283); ctx.fill(); }
          ctx.restore();
        }
        for (var m = drops.length - 1; m >= 0; m--) {
          var d = drops[m], dd = Math.min(34, now - d.t) / 16.67; d.t = now;
          d.vy += d.g * dd; d.x += d.vx * dd; d.y += d.vy * dd; d.life -= (d.fizz ? .022 : .045) * dd;
          if (d.fizz && d.y < d.top) d.life = 0;
          if (d.life <= 0) { drops.splice(m, 1); continue; }
          ctx.globalAlpha = Math.max(0, Math.min(1, d.life)); ctx.fillStyle = d.c; ctx.beginPath(); ctx.arc(d.x, d.y, d.rad, 0, 6.283); ctx.fill();
        }
        ctx.globalAlpha = 1;
        if (parts.length || drops.length || root._streaming) raf = requestAnimationFrame(loop);
        else ctx.clearRect(0, 0, W, H);
      }
      function kick() { if (!raf) raf = requestAnimationFrame(loop); }
      function stream(pack, glass, lip, dir, dur, my) {
        var tablet = kindOf(pack) === 'tablet', col = colours(glass, tablet), t0 = performance.now(), last = t0, dropped = 0;
        var cs = getComputedStyle(glass), v = rel($('.glass__vessel', glass)), food = parseFloat(cs.getPropertyValue('--food')) || 50, need = parseFloat(cs.getPropertyValue('--need')) || 86;
        var floor = function () { return v.y + v.h - v.h * (food + (need - food) * Math.min(1, lvlOf(glass))) / 100 - 2; };
        var cx = v.x + v.w / 2;
        root._streaming = true;
        return new Promise(function (resolve) {
          (function spawn() {
            if (my !== run) { root._streaming = false; resolve(); return; }
            var now = performance.now(), el = now - t0;
            if (el > dur) { root._streaming = false; resolve(); return; }
            if (tablet) {
              var want = 1;
              while (dropped < want) { dropped++; parts.push({ tab: true, col: col, x: lip.x, y: lip.y, vx: (cx - lip.x) / 26 + (Math.random() - .5) * .4, vy: .6, r: Math.random() * 3, vr: dir * (.08 + Math.random() * .12), a: 1, t: now, floor: floor }); }
            } else {
              var steps = Math.max(1, Math.round((now - last) / 16.67)); last = now;
              var ramp = Math.min(1, el / 260, (dur - el) / 360);
              for (var s = 0; s < steps * Math.round(3 + 7 * ramp); s++) {
                var r = Math.random(), spread = 2 + 6 * ramp;
                parts.push({ x: lip.x + (Math.random() - .5) * spread, y: lip.y + Math.random() * 2, vx: (cx - lip.x) / 34 + (Math.random() - .5) * .5, vy: .5 + Math.random() * .9, r: 0, vr: 0,
                  size: .9 + Math.random() * 2.2, a: .75 + Math.random() * .25, c: r > .7 ? col.hi : (r > .25 ? col.body : col.lo), t: now, floor: floor });
              }
            }
            kick(); requestAnimationFrame(spawn);
          })();
        });
      }
      /* The level glides up with the pour, then settles with a tiny slosh */
      function animateLvl(g, from, to, dur, my) {
        return new Promise(function (resolve) {
          var t0 = performance.now();
          (function step() {
            if (my !== undefined && my !== run) { resolve(); return; }
            var u = Math.min(1, (performance.now() - t0) / dur), e = -(Math.cos(Math.PI * u) - 1) / 2;
            g.style.setProperty('--lvl', (from + (to - from) * e).toFixed(4));
            if (u < 1) requestAnimationFrame(step); else { g.style.setProperty('--lvl', to); resolve(); }
          })();
        });
      }
      function move(pk, tx, ty, ang, ms) {
        pk.style.transition = 'transform ' + Math.round(ms) + 'ms cubic-bezier(.45, .05, .25, 1)';
        pk.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) rotate(' + ang + 'deg)';
      }
      /* The cap twists off and lifts; once the pack leaves, it is set down on the plinth where the pack stood.
         When the pack comes home the cap lifts again, the pack slides under it, and it twists back on. */
      function capOf(pk) { return $('.gap__cap', pk.parentNode); }
      function capState(cap, st) { cap.classList.remove('cap--off', 'cap--park', 'cap--lift', 'cap--on', 'cap--aside', 'cap--unaside'); if (st) { void cap.offsetWidth; cap.classList.add('cap--' + st); } }
      /* Mixes: the tub stays put; its lid is leant against the side of the tub, on the outer side */
      function asideCap(pk) {
        var wrap = pk.parentNode, cap = capOf(pk), all = $$('.gap__packwrap', wrap.parentNode), i = all.indexOf(wrap);
        if (!cap) return;
        wrap.style.setProperty('--pw', pk.offsetWidth + 'px');
        wrap.style.setProperty('--side', (all.length > 1 && i === 0) ? -1 : 1);
        capState(cap, 'aside');
      }
      function openCap(pk) {
        var wrap = pk.parentNode, cap = capOf(pk);
        if (!cap || wrap.classList.contains('is-open')) return Promise.resolve();
        wrap.classList.add('is-active', 'is-open'); capState(cap, 'off');
        return wait(520 * k);
      }
      function parkCap(pk) { var cap = capOf(pk); if (cap && pk.parentNode.classList.contains('is-open') && !cap.classList.contains('cap--park')) capState(cap, 'park'); }
      function home(pk, my) {
        var wrap = pk.parentNode, cap = capOf(pk);
        if (!pk.style.transform) {
          if (cap && wrap.classList.contains('is-open')) {
            var pre = cap.classList.contains('cap--aside') ? (capState(cap, 'unaside'), wait(460)) : Promise.resolve();
            return pre.then(function () { capState(cap, 'on'); return wait(560); }).then(function () { wrap.classList.remove('is-open', 'is-active'); capState(cap, null); });
          }
          wrap.classList.remove('is-active'); return Promise.resolve();
        }
        if (cap && wrap.classList.contains('is-open')) capState(cap, 'lift');
        move(pk, 0, 0, 0, 700);
        return wait(720).then(function () {
          pk.style.transform = ''; pk.style.transition = ''; pk.classList.remove('is-pouring');
          if (cap && wrap.classList.contains('is-open')) { capState(cap, 'on'); return wait(560).then(function () { wrap.classList.remove('is-open', 'is-active'); capState(cap, null); }); }
          wrap.classList.remove('is-active');
        });
      }
      function homeAll(p, my) { return Promise.all($$('[data-gap-pack]', p).map(function (pk) { return home(pk, my); })); }
      function geometry(pack, glass) {
        var prev = pack.style.transform, prevT = pack.style.transition; pack.style.transition = 'none'; pack.style.transform = '';
        var pr = rel(pack); pack.style.transform = prev; void pack.offsetWidth; pack.style.transition = prevT;
        var v = rel($('.glass__vessel', glass)), g = GEO[kindOf(pack)];
        var gx = v.x + v.w / 2, pivot = { x: pr.x + pr.w / 2, y: pr.y + pr.h * .8 };
        var dir = gx >= pivot.x ? 1 : -1, A = g.ang * Math.PI / 180;
        var d = pr.h * (.8 - g.mouth), a = pr.w * g.lip;
        var lipOff = { x: dir * (a * Math.cos(A) + d * Math.sin(A)), y: a * Math.sin(A) - d * Math.cos(A) };
        var above = Math.max(34, Math.min(58, v.h * .26));
        var tx = gx - lipOff.x - pivot.x - dir * 4, ty = v.y - above - lipOff.y - pivot.y;
        return { tx: tx, ty: ty, dir: dir, ang: g.ang * dir, lip: { x: gx - dir * 4, y: v.y - above } };
      }
      function place(el, x, y, r, ms, ease) {
        el.style.transition = ms ? 'transform ' + Math.round(ms) + 'ms ' + (ease || 'cubic-bezier(.45, .05, .25, 1)') + ', opacity .3s' : 'none';
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + r + 'deg)';
      }
      function fillLevel(p, g, startMs, durMs, my) {
        wait(startMs).then(function () { return animateLvl(g, lvlOf(g), 1.025, durMs, my); }).then(function () {
          if (my !== run) return;
          return animateLvl(g, 1.025, 1, 460, my);
        }).then(function () {
          if (my !== run) return;
          g.classList.remove('is-pouring'); g.classList.add('is-filled', 'is-hit');
          setTimeout(function () { g.classList.remove('is-hit'); }, 700);
          setCount(p, true);
        });
      }
      /* Mixes: a scoop rises out of the open tub, travels over the glass, tips and pours, then goes back for the next one */
      function scoopOne(p, g, pk, first, my) {
        var wrap = pk.parentNode, sc = $('.gap__scoop', wrap), bowl = sc && $('.gap__scoop-bowl', sc), lipEl = sc && $('.gap__scoop-lip', sc);
        if (!sc) return Promise.resolve();
        var v = rel($('.glass__vessel', g)), pr = rel(pk), gx = v.x + v.w / 2, dir = gx >= pr.x + pr.w / 2 ? 1 : -1;
        sc.classList.toggle('is-flip', dir > 0); sc.classList.remove('is-empty');
        var up = -Math.max(40, pr.h * .3);
        place(sc, 0, 24, 0, 0); sc.style.opacity = 0; void sc.offsetWidth;
        return (first ? wait(80) : Promise.resolve()).then(function () {
          if (my !== run) return;
          sc.style.opacity = 1; place(sc, 0, up, 0, 420 * k);
          return wait(440 * k);
        }).then(function () {
          if (my !== run) return;
          var b = rel(bowl), above = Math.max(30, Math.min(52, v.h * .22));
          var dx = gx - (b.x + b.w / 2), dy = (v.y - above) - (b.y + b.h / 2);
          sc._to = { x: dx, y: up + dy }; sc.classList.add('is-out');
          place(sc, dx, up + dy, -dir * 10, 620 * k);
          return wait(640 * k);
        }).then(function () {
          if (my !== run) return;
          place(sc, sc._to.x, sc._to.y, dir * 112, 380 * k, 'cubic-bezier(.3, .1, .3, 1)');
          return wait(330 * k);
        }).then(function () {
          if (my !== run) return;
          var L = rel(lipEl), lip = { x: L.x + L.w / 2, y: L.y + L.h / 2 }, pourMs = 1050 * k;
          sc.classList.add('is-empty');
          fillLevel(p, g, 200 * k, pourMs + 520 * k, my);
          return stream(pk, g, lip, dir, pourMs, my);
        }).then(function () {
          if (my !== run) return;
          place(sc, sc._to.x, sc._to.y - 8, 0, 360 * k);
          return wait(300 * k);
        }).then(function () {
          if (my !== run) return;
          place(sc, 0, up, 0, 560 * k);
          return wait(560 * k);
        }).then(function () {
          if (my !== run) return;
          sc.classList.remove('is-out'); place(sc, 0, 24, 0, 300 * k); sc.style.opacity = 0;
          return wait(240 * k);
        });
      }
      /* One glass: mixes get a scoop from the tub, tablets: the bottle tips one tablet in */
      function pourOne(p, g, my) {
        var pk = packFor(p, g), first = cur !== pk;
        var pre = (cur && first) ? home(cur, my) : Promise.resolve();
        cur = pk;
        g.classList.remove('is-queued'); g.classList.add('is-pouring');
        return pre.then(function () { return first ? openCap(pk) : null; }).then(function () {
          if (my !== run) return;
          if (kindOf(pk) === 'drop') {
            if (first) asideCap(pk);
            return scoopOne(p, g, pk, first, my);
          }
          var geo = geometry(pk, g), travel = (first ? 760 : 580) * k;
          pk.classList.add('is-pouring');
          move(pk, geo.tx, geo.ty, geo.dir * 22, travel);
          if (first) setTimeout(function () { if (my === run) parkCap(pk); }, 220 * k);
          return wait(travel - 60 * k).then(function () {
            if (my !== run) return;
            move(pk, geo.tx, geo.ty, geo.ang, 460 * k);
            return wait(330 * k);
          }).then(function () {
            if (my !== run) return;
            var pourMs = 700 * k;
            var s = stream(pk, g, geo.lip, geo.dir, pourMs, my);
            /* one tablet drops in; the level rises as it fizzes and dissolves */
            fillLevel(p, g, 420 * k, 1300 * k, my);
            return s.then(function () {
              if (my !== run) return;
              move(pk, geo.tx, geo.ty - 12, geo.dir * 18, 420 * k);
              return wait(160 * k);
            });
          });
        });
      }
      function pump() {
        if (busy) return;
        var p = panel(); if (!p) return;
        var g = queue.shift();
        if (!g) {
          clearTimeout(idle);
          idle = setTimeout(function () { if (!busy && !queue.length && cur) { var c = cur; cur = null; home(c, run); } }, 1100);
          return;
        }
        clearTimeout(idle); busy = true;
        var my = run;
        pourOne(p, g, my).then(function () { if (my !== run) return; busy = false; pump(); });
      }
      function enqueue(g) {
        if (g.classList.contains('is-filled') || g.classList.contains('is-pouring') || queue.indexOf(g) > -1) return;
        g.classList.add('is-queued'); queue.push(g); setCount(g.closest('[data-gap-panel]'));
        if (reduced) { queue.length = 0; g.classList.remove('is-queued'); g.classList.add('is-filled'); g.style.setProperty('--lvl', 1); setCount(g.closest('[data-gap-panel]'), true); return; }
        size(); pump();
      }
      function emptyOne(g) {
        var i = queue.indexOf(g); if (i > -1) { queue.splice(i, 1); g.classList.remove('is-queued'); }
        if (!g.classList.contains('is-filled')) return;
        g.classList.remove('is-filled'); g.classList.add('is-draining');
        var p = g.closest('[data-gap-panel]'); setCount(p);
        if (reduced) { g.style.setProperty('--lvl', 0); g.classList.remove('is-draining'); return; }
        animateLvl(g, lvlOf(g) || 1, 0, 700).then(function () { g.classList.remove('is-draining'); });
      }
      function fillAll() { var p = panel(); if (!p) return; $$('[data-gap-glass]', p).forEach(enqueue); setCount(p); }
      function reset(p, quick) {
        run++; queue.length = 0; busy = false; clearTimeout(idle); parts.length = 0; root._streaming = false;
        var my = run;
        homeAll(p, my).then(function () { if (my === run) cur = null; }); if (quick) cur = null;
        $$('[data-gap-glass]', p).forEach(function (g) {
          g.classList.remove('is-filled', 'is-pouring', 'is-queued');
          if (quick || reduced) { g.style.setProperty('--lvl', 0); return; }
          g.classList.add('is-draining'); animateLvl(g, lvlOf(g), 0, 700).then(function () { g.classList.remove('is-draining'); });
        });
        setCount(p);
      }
      function prime(cb) {
        root.classList.remove('is-primed'); void root.offsetWidth;
        requestAnimationFrame(function () { root.classList.add('is-primed'); if (cb) setTimeout(cb, reduced ? 0 : 1500); });
      }
      on(toggle, 'click', function () { var p = panel(); if (!p) return; if (toggle.getAttribute('aria-pressed') === 'true') reset(p); else fillAll(); });
      $$('[data-gap-tap]', root).forEach(function (v) {
        var g = v.closest('[data-gap-glass]');
        var act = function () { root.classList.add('is-touched'); if (g.classList.contains('is-filled')) emptyOne(g); else enqueue(g); };
        on(v, 'click', act);
        on(v, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); act(); } });
      });
      on(root, 'uv:tabchange', function () {
        $$('[data-gap-panel]', root).forEach(function (p) { reset(p, true); });
        prime(seen && auto ? fillAll : null);
      });
      if (!('IntersectionObserver' in window) || reduced) {
        root.classList.add('is-primed'); seen = true;
        var p0 = panel(); if (p0) { $$('[data-gap-glass]', p0).forEach(function (g) { g.classList.add('is-filled'); g.style.setProperty('--lvl', 1); }); setCount(p0); }
        return;
      }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect(); seen = true;
        prime(auto ? fillAll : null);
      }, { threshold: 0.3 });
      io.observe(root);
    });
  }

  /* ---------- Range slider (centre card with side peeks) ---------- */
  function initRange() {
    $$('[data-range]').forEach(function (root) {
      var track = $('.range-track', root), cards = $$('.range-card', root), tabs = $$('[data-range-tab]', root), i = 0;
      if (!cards.length) return;
      function go(n) {
        i = Math.max(0, Math.min(cards.length - 1, n));
        var card = cards[i], stage = track.parentElement;
        var offset = card.offsetLeft - (stage.clientWidth - card.offsetWidth) / 2;
        track.style.transform = 'translateX(' + (-offset) + 'px)';
        cards.forEach(function (c, k) { c.classList.toggle('is-active', k === i); c.setAttribute('aria-hidden', k === i ? 'false' : 'true'); $$('a, button, input', c).forEach(function (f) { f.tabIndex = k === i ? 0 : -1; }); });
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        var at = tabs[i]; if (at && at.parentElement.scrollWidth > at.parentElement.clientWidth) at.parentElement.scrollTo({ left: at.offsetLeft - 20, behavior: 'smooth' });
      }
      tabs.forEach(function (t, k) { on(t, 'click', function () { go(k); }); });
      on($('[data-range-prev]', root), 'click', function () { go(i - 1); });
      on($('[data-range-next]', root), 'click', function () { go(i + 1); });
      cards.forEach(function (c, k) { on(c, 'click', function (e) { if (k !== i) { e.preventDefault(); go(k); } }); });
      var x0 = null;
      on(track, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      on(track, 'touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
      window.addEventListener('resize', function () { go(i); });
      go(0);
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]'); if (!btn) return;
    var input = $('input', btn.closest('.qty')); if (!input) return;
    var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 1;
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + Number(btn.getAttribute('data-qty-step')));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Gallery ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (g) {
      var track = $('.gallery__track', g), slides = $$('.gallery__slide', g), thumbs = $$('[data-thumb]', g), dots = $$('.gallery__dots span', g), count = $('.gallery__count b', g);
      var chips = $$('[data-gallery-chip]', g), chipBar = $('.gallery__chips', g);
      if (!track) return;
      function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      function mark(n) {
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === n ? 'true' : 'false'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
        if (count) count.textContent = n + 1;
        chips.forEach(function (c, k) { var a = k === n; c.classList.toggle('is-active', a); if (a && chipBar) { var l = c.offsetLeft - chipBar.clientWidth / 2 + c.offsetWidth / 2; chipBar.scrollTo({ left: Math.max(0, l), behavior: reduced ? 'auto' : 'smooth' }); } });
      }
      function go(n) { n = (n + slides.length) % slides.length; track.scrollTo({ left: n * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); mark(n); }
      g._go = function (mediaId) { var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); }); if (idx > -1) go(idx); };
      thumbs.forEach(function (t, k) { on(t, 'click', function () { go(k); }); });
      chips.forEach(function (c, k) { on(c, 'click', function () { go(k); }); });
      on($('[data-gallery-prev]', g), 'click', function () { go(current() - 1); });
      on($('[data-gallery-next]', g), 'click', function () { go(current() + 1); });
      var st; on(track, 'scroll', function () { clearTimeout(st); st = setTimeout(function () { mark(current()); }, 60); }, { passive: true });
      if (window.matchMedia('(hover: hover) and (min-width: 961px)').matches) {
        slides.forEach(function (s) {
          on(s, 'click', function () { s.classList.toggle('is-zoomed'); });
          on(s, 'mousemove', function (e) { var r = s.getBoundingClientRect(); s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); });
          on(s, 'mouseleave', function () { s.classList.remove('is-zoomed'); });
        });
      }
    });
  }

  /* ---------- Product forms: variants, purchase options, price ---------- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (root) {
      var json = $('[data-variant-json]', root), variants = [];
      try { variants = JSON.parse(json ? json.textContent : '[]'); } catch (err) { variants = []; }
      var section = root.closest('[data-product-section]') || root.closest('.product-card') || document;
      var idInput = $('input[name="id"]', root), planInput = $('input[name="selling_plan"]', root);
      var addBtn = $('[data-add-button]', root), addPrice = $('[data-add-price]', root), addLabel = $('[data-add-label]', root);
      var current = variants.find(function (v) { return String(v.id) === (idInput && idInput.value); }) || variants[0];

      function planFor(v) {
        var sel = $('input[name="purchase_type"]:checked', root);
        if (!sel || sel.value !== 'subscribe') return null;
        var freq = $('[data-plan-select]', root);
        var pid = freq ? freq.value : sel.getAttribute('data-plan');
        var alloc = (v.selling_plan_allocations || []).find(function (a) { return String(a.selling_plan_id) === String(pid); });
        return alloc ? { id: pid, price: alloc.price } : (pid ? { id: pid, price: v.price } : null);
      }
      function render() {
        if (!current) return;
        var plan = planFor(current), price = plan ? plan.price : current.price;
        if (idInput) idInput.value = current.id;
        if (planInput) planInput.value = plan ? plan.id : '';
        $$('[data-price-amount]', section).forEach(function (el) { el.textContent = formatMoney(price); });
        $$('[data-compare-amount]', section).forEach(function (el) {
          var cmp = plan ? current.price : current.compare_at_price;
          el.textContent = cmp && cmp > price ? formatMoney(cmp) : ''; el.hidden = !(cmp && cmp > price);
        });
        $$('[data-onetime-price]', root).forEach(function (el) { el.textContent = formatMoney(current.price); });
        $$('[data-sub-price]', root).forEach(function (el) { var p = (current.selling_plan_allocations || [])[0]; el.textContent = formatMoney(p ? p.price : current.price); });
        if (addPrice) addPrice.textContent = formatMoney(price);
        if (addBtn) addBtn.disabled = !current.available;
        if (addLabel) addLabel.textContent = current.available ? (theme.strings.addToCart || 'Add to cart') : (theme.strings.soldOut || 'Sold out');
        $$('[data-option-label]', root).forEach(function (el) { el.textContent = current.title; });
        $$('[data-sticky-price]').forEach(function (el) { el.textContent = formatMoney(price); });
      }
      root.addEventListener('change', function (e) {
        if (e.target.matches('[data-option-index]')) {
          var sel = [];
          $$('[data-option-group]', root).forEach(function (fs) { var c = $('input:checked', fs); if (c) sel[Number(c.getAttribute('data-option-index'))] = c.value; });
          var match = variants.find(function (v) { return v.options.every(function (o, k) { return sel[k] === undefined || o === sel[k]; }); });
          if (match) {
            current = match;
            if (match.featured_media) { var g = $('[data-gallery]', section); if (g && g._go) g._go(match.featured_media.id); }
            var card = root.closest('.product-card');
            if (card) {
              var packs = {}, pj = $('[data-variant-packs]', root);
              try { packs = JSON.parse(pj ? pj.textContent : '{}') || {}; } catch (err) { packs = {}; }
              var img = $('.product-card__pack', card), src = packs[String(match.id)];
              if (img && src) { img.removeAttribute('srcset'); img.classList.remove('is-swapping'); void img.offsetWidth; img.classList.add('is-swapping'); img.src = src; }
            }
            var url = root.getAttribute('data-url');
            if (url && !card && window.history.replaceState && location.pathname.indexOf('/products/') > -1) window.history.replaceState({}, '', url + '?variant=' + match.id);
          }
        }
        render();
      });
      render();
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc() {
    var bar = $('[data-sticky-atc]'), main = $('[data-product-section] [data-add-button]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0]; bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(main);
    on($('[data-sticky-add]', bar), 'click', function () { main.click(); });
  }

  /* ---------- Finder quiz ---------- */
  function initFinder() {
    $$('[data-finder]').forEach(function (root) {
      var steps = $$('.finder__step', root), bars = $$('.finder__progress i', root), answers = {}, aside = $('[data-finder-aside]', root);
      function show(n) {
        steps.forEach(function (s, k) { s.hidden = k !== n; });
        var name = steps[n] && steps[n].getAttribute('data-step');
        var prog = { who: 0, kid: 2, age: 1, goal: 2, result: 3 }[name]; if (prog == null) prog = n;
        bars.forEach(function (b, k) { b.classList.toggle('is-done', k <= prog); });
      }
      function result() {
        var who = answers.who, age = answers.age || 'any', goal = answers.goal || 'both';
        var cards = $$('[data-result]', root), hit = [];
        cards.forEach(function (c) {
          var w = c.getAttribute('data-who').split(','), a = c.getAttribute('data-age').split(',');
          var ok = w.indexOf(who) > -1 && (a.indexOf(age) > -1 || a.indexOf('any') > -1);
          c.hidden = true; if (ok) hit.push(c);
        });
        var isP = function (c) { return c.getAttribute('data-protein') === 'true'; };
        var prot = hit.filter(isP), daily = hit.filter(function (c) { return !isP(c); });
        if (goal === 'protein' && prot.length) hit = prot;
        else if (goal === 'daily' && daily.length) hit = daily;
        else hit = daily.concat(prot);
        hit.forEach(function (c, k) { c.hidden = false; c.style.setProperty('--d', k); });
        $('[data-finder-empty]', root).hidden = hit.length > 0;
        var title = $('[data-finder-title]', root);
        if (title) title.textContent = title.getAttribute(hit.length > 1 ? 'data-many' : 'data-one') || title.textContent;
        if (aside && hit[0]) {
          aside.setAttribute('style', hit[0].getAttribute('data-vars') || '');
          var packs = $('.finder__packs', aside);
          if (packs) packs.innerHTML = hit.slice(0, 2).map(function (c) { return '<img src="' + c.getAttribute('data-pack') + '" alt="">'; }).join('');
        }
        show(steps.length - 1);
      }
      var history = [];
      function idx(name) { return steps.findIndex(function (s) { return s.getAttribute('data-step') === name; }); }
      function go(name) { var cur = steps.findIndex(function (s) { return !s.hidden; }); if (cur > -1) history.push(cur); show(idx(name)); }
      root.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-answer]');
        if (opt) {
          var key = opt.getAttribute('data-key'), val = opt.getAttribute('data-answer');
          answers[key] = val;
          var step = opt.closest('.finder__step');
          $$('[data-answer]', step).forEach(function (o) { o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'); });
          setTimeout(function () {
            var name = step.getAttribute('data-step');
            if (name === 'who' && val === 'kid') go('kid');
            else if (name === 'kid') { answers.age = 'any'; answers.goal = 'daily'; history.push(steps.indexOf(step)); result(); }
            else if (name === 'who') go('age');
            else if (name === 'age') go('goal');
            else { history.push(steps.indexOf(step)); result(); }
          }, reduced ? 0 : 220);
        }
        if (e.target.closest('[data-finder-back]')) { show(history.length ? history.pop() : 0); }
        if (e.target.closest('[data-finder-restart]')) { answers = {}; history = []; $$('[aria-pressed]', root).forEach(function (o) { o.setAttribute('aria-pressed', 'false'); }); show(0); }
      });
      show(0);
    });
  }

  /* ---------- Collection: need filter + instant sort ---------- */
  function initCollection() {
    $$('[data-collection]').forEach(function (root) {
      var grid = $('.product-grid', root), cards = $$('.product-card', grid), count = $('[data-result-count]', root), chips = $$('[data-need]', root), sort = $('[data-client-sort]', root);
      if (!grid) return;
      cards.forEach(function (c, k) { c.setAttribute('data-order', k); });
      function apply(need) {
        var shown = 0;
        cards.forEach(function (c) { var ok = !need || (c.getAttribute('data-needs') || '').split(' ').indexOf(need) > -1; c.classList.toggle('is-filtered', !ok); if (ok) shown++; });
        chips.forEach(function (ch) { ch.setAttribute('aria-pressed', (ch.getAttribute('data-need') || '') === (need || '') ? 'true' : 'false'); });
        if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
        grid.classList.toggle('is-sorted', !!need || (sort && sort.selectedIndex > 0));
      }
      chips.forEach(function (ch) { on(ch, 'click', function () { apply(ch.getAttribute('data-need')); }); });
      function fromHash() { var m = /^#need-([a-z0-9-]+)$/.exec(location.hash || ''); if (m && chips.some(function (c) { return c.getAttribute('data-need') === m[1]; })) apply(m[1]); }
      fromHash(); on(window, 'hashchange', fromHash);
      on(sort, 'change', function () {
        var v = sort.value;
        grid.classList.toggle('is-sorted', sort.selectedIndex > 0 || chips.some(function (c) { return c.getAttribute('aria-pressed') === 'true' && c.getAttribute('data-need'); }));
        cards.slice().sort(function (a, b) {
          var pa = Number(a.getAttribute('data-price')), pb = Number(b.getAttribute('data-price'));
          if (v === 'price-ascending') return pa - pb;
          if (v === 'price-descending') return pb - pa;
          if (v === 'title-ascending') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
          if (v === 'title-descending') return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
          return a.getAttribute('data-order') - b.getAttribute('data-order');
        }).forEach(function (c) { grid.appendChild(c); });
      });
    });
  }

  function initReadProgress() {
    var bar = $('[data-read-progress]'); if (!bar) return;
    var body = $('.article-page') || document.body, ticking = false;
    function upd() { ticking = false; var r = body.getBoundingClientRect(), h = r.height - innerHeight; bar.style.setProperty('--p', Math.min(1, Math.max(0, -r.top / (h || 1)))); }
    on(window, 'scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }

  /* ---------- Story videos ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-story-play]'); if (!b) return;
    var v = $('video', b.closest('.story'));
    if (v) { if (v.paused) { v.play(); b.hidden = true; } else v.pause(); }
  });

  /* ---------- Cart ---------- */
  var drawer = $('[data-cart-drawer]'), lastFocus = null;
  function openDrawer() {
    if (!drawer) { location.href = theme.routes.cart || '/cart'; return; }
    lastFocus = document.activeElement; drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
    var p = $('.drawer__panel', drawer); if (p) setTimeout(function () { p.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus();
  }
  theme.openDrawer = openDrawer; theme.closeDrawer = closeDrawer;
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }); }
  function refreshDrawer() {
    return fetch((theme.routes.root || '/') + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.drawer__panel'), cur = drawer && $('.drawer__panel', drawer);
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; initRails(); }
      return fetch((theme.routes.cart || '/cart') + '.js');
    }).then(function (r) { return r.json(); }).then(function (cart) { setCount(cart.item_count); return cart; });
  }
  theme.refreshDrawer = refreshDrawer; theme.initRails = initRails;
  function addItems(body, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return fetch((theme.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || theme.strings.cartError);
        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); var lbl = $('[data-add-label]', btn); var old = lbl && lbl.textContent; if (lbl) lbl.textContent = theme.strings.added || 'Added'; setTimeout(function () { btn.classList.remove('is-added'); if (lbl) lbl.textContent = old; }, 1600); }
        if (theme.cartType === 'drawer' && drawer) return refreshDrawer().then(openDrawer);
        location.href = theme.routes.cart || '/cart';
      })
      .catch(function (err) { toast(err.message || theme.strings.cartError); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }
  theme.addItems = addItems;
  document.addEventListener('submit', function (e) {
    var form = e.target, action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action) || theme.cartType !== 'drawer' || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (form.hasAttribute('data-bundle-form')) {
      var items = $$('input[name="bundle_item"]', form).map(function (i) { return { id: Number(i.value), quantity: 1 }; });
      addItems({ items: items }, btn); return;
    }
    var fd = new FormData(form), item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
    addItems({ items: [item] }, btn);
  });
  if (drawer) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
      if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
      var lineBtn = e.target.closest('[data-cart-drawer] [data-line]');
      if (lineBtn) {
        lineBtn.disabled = true;
        fetch((theme.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(lineBtn.getAttribute('data-line')), quantity: Number(lineBtn.getAttribute('data-quantity')) }) })
          .then(refreshDrawer).catch(function () { lineBtn.disabled = false; });
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  $$('[data-autosubmit]').forEach(function (input) { var t; on(input, 'change', function () { clearTimeout(t); t = setTimeout(function () { input.form && input.form.submit(); }, 600); }); });









































  /* ==== v6 start ==== */
  /* ---------- Wishlist (kept in the shopper's browser) ---------- */
  var WKEY = 'uv-wishlist', memWish = null;
  function wishGet() { try { var v = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return memWish || []; } }
  function wishSet(list) { memWish = list; try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {} }
  function wishSync(removed) {
    var list = wishGet();
    $$('[data-wish]').forEach(function (b) {
      var on_ = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
      var lab = b.getAttribute(on_ ? 'data-label-remove' : 'data-label-add'); if (lab) b.setAttribute('aria-label', lab);
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
    $$('[data-wish-link]').forEach(function (l) { l.classList.toggle('has-items', list.length > 0); });
    var grid = $('[data-wish-grid]'); if (!grid) return;
    var shown = 0;
    $$('.product-card', grid).forEach(function (c) {
      var h = c.getAttribute('data-handle'), idx = list.indexOf(h), keep = idx > -1;
      c.style.order = keep ? idx : 999;
      if (!keep && h === removed && !reduced && !c.classList.contains('is-wish-hidden')) {
        c.classList.add('is-wish-leaving');
        setTimeout(function () { c.classList.remove('is-wish-leaving'); c.classList.add('is-wish-hidden'); }, 430);
      } else c.classList.toggle('is-wish-hidden', !keep);
      if (keep) { shown++; c.classList.remove('is-pending'); c.classList.add('is-in'); }
    });
    var empty = $('[data-wish-empty]'), sum = $('[data-wish-summary]');
    setTimeout(function () { if (empty) empty.hidden = list.length > 0; grid.style.display = list.length ? '' : 'none'; }, removed && !reduced ? 440 : 0);
    if (sum) sum.textContent = list.length ? (list.length === 1 ? sum.getAttribute('data-one') : (sum.getAttribute('data-other') || '').replace(/\d+/, list.length)) : '';
  }
  function initWishlist() {
    if (!document.documentElement.classList.contains('has-wishlist') && !$('[data-wish]')) return;
    if (!initWishlist.bound) {
      initWishlist.bound = true;
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-wish]'); if (!b) return;
        e.preventDefault(); e.stopPropagation();
        var h = b.getAttribute('data-wish'), list = wishGet(), i = list.indexOf(h), added = i === -1;
        if (added) list.unshift(h); else list.splice(i, 1);
        wishSet(list);
        if (added && !reduced) { b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 700); }
        $$('[data-wish-link]').forEach(function (l) { l.classList.remove('is-bump'); void l.offsetWidth; l.classList.add('is-bump'); setTimeout(function () { l.classList.remove('is-bump'); }, 420); });
        toast(added ? (theme.strings.wishAdded || 'Saved to your wishlist') : (theme.strings.wishRemoved || 'Removed from your wishlist'));
        wishSync(added ? null : h);
      });
      window.addEventListener('storage', function (e) { if (e.key === WKEY) wishSync(); });
    }
    wishSync();
  }

  /* ---------- Key ingredients: tabs that move on their own until the shopper picks one ---------- */
  function initKi() {
    $$('[data-ki]').forEach(function (root) {
      if (root._ki) return; root._ki = true;
      var tabs = $$('[role="tab"]', root), panels = $$('[role="tabpanel"]', root), list = $('[data-ki-list]', root), cur = 0;
      var auto = root.getAttribute('data-autoplay') === 'true' && !reduced && tabs.length > 1;
      root.style.setProperty('--ki-interval', (parseFloat(root.getAttribute('data-interval')) || 6) + 's');
      function restartBar() { var bar = $('.ki-card__bar i', tabs[cur]); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; } }
      function select(n, focus, user) {
        cur = (n + tabs.length) % tabs.length;
        tabs.forEach(function (t, k) { var s = k === cur; t.setAttribute('aria-selected', s ? 'true' : 'false'); t.tabIndex = s ? 0 : -1; });
        panels.forEach(function (p, k) {
          if (k === cur) { p.hidden = false; p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); }
          else { p.hidden = true; p.classList.remove('is-in'); }
        });
        if (focus) tabs[cur].focus({ preventScroll: true });
        if (list && list.scrollWidth > list.clientWidth + 4) list.scrollTo({ left: Math.max(0, tabs[cur].offsetLeft - 16), behavior: reduced ? 'auto' : 'smooth' });
        if (user) { auto = false; root.classList.remove('is-auto'); } else restartBar();
      }
      tabs.forEach(function (t, k) {
        on(t, 'click', function () { select(k, false, true); });
        on(t, 'keydown', function (e) {
          var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!d) return; e.preventDefault(); select(k + d, true, true);
        });
      });
      on(root, 'animationend', function (e) { if (auto && e.animationName === 'ki-progress') select(cur + 1); });
      on(root, 'mouseenter', function () { root.classList.add('is-paused'); });
      on(root, 'mouseleave', function () { root.classList.remove('is-paused'); });
      if (panels[0]) panels[0].classList.add('is-in');
      if (!auto) return;
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var vis = es[0].isIntersecting;
          if (vis && !root.classList.contains('is-auto') && auto) { root.classList.add('is-auto'); restartBar(); }
          root.classList.toggle('is-paused', !vis || root.matches(':hover'));
        }, { threshold: 0.35 }).observe(root);
      } else { root.classList.add('is-auto'); }
    });
  }

  /* ---------- Scroll motion: words that rise, staggered grids, unveiled images, parallax, card tilt ---------- */
  function splitWords(el) {
    var w = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var parts = ch.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (t) {
            if (!t) return;
            if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
            var o = document.createElement('span'), i = document.createElement('span');
            o.className = 'split-w'; i.textContent = t; i.style.setProperty('--w', w++); o.appendChild(i); frag.appendChild(o);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && !/^(BR|SVG|IMG)$/i.test(ch.tagName)) walk(ch);
      });
    })(el);
    el.setAttribute('data-split', '');
  }
  function initMotion() {
    var html = document.documentElement;
    var fx = !reduced && !html.classList.contains('no-scrollfx') && !html.classList.contains('no-reveal') && 'IntersectionObserver' in window;
    if (!fx) return;
    var vh = window.innerHeight;
    /* 1. Headings rise word by word */
    var heads = $$('.section .h2, .gap__title, .closing .h1, .col-head__title, .wishlist__title .h1, .faq__intro .h2').filter(function (h) {
      return !h.hasAttribute('data-split') && !h.closest('.hero, .mega, .drawer, .mobile-menu, .site-header, .ki-panel, [data-no-split]') && h.textContent.trim().length < 140;
    });
    var hio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('split-in'); hio.unobserve(e.target); } }); }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
    heads.forEach(function (h) { splitWords(h); hio.observe(h); });
    /* 2. Staggered grids and rails */
    var grids = $$('.rail, .needs, .stats, .science-facts, .how__steps, .post-grid, .closing__lineup, .faq__list, .highlights__list, .pcompare__list, .ki__grid, .mcol, .col-tiles, .stage-nav, .ladder-art__steps').filter(function (g) {
      return !g.hasAttribute('data-stagger') && g.children.length > 1 && !g.querySelector(':scope > [data-reveal]') && !g.closest('.mega, .mobile-menu, .drawer');
    });
    var gio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; gio.unobserve(e.target);
        var g = e.target; requestAnimationFrame(function () { g.classList.add('is-staged'); g.classList.remove('is-staging'); });
        setTimeout(function () { g.classList.add('is-settled'); }, 900 + g.children.length * 70);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    grids.forEach(function (g) {
      if (g.getBoundingClientRect().top < vh * .9) return;
      g.setAttribute('data-stagger', ''); g.classList.add('is-staging');
      Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--si', Math.min(i, 10)); });
      gio.observe(g);
    });
    /* 3. Images unveil */
    var imgs = $$('.iwt__media, .banner__media, .post-lead__media, .vid__media, .science-card, .feature-card__art').filter(function (m) { return m.getBoundingClientRect().top > vh * .85; });
    var iio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('is-pending-img'); iio.unobserve(e.target); } }); }, { threshold: 0.15 });
    imgs.forEach(function (m) { m.classList.add('img-reveal', 'is-pending-img'); iio.observe(m); });
    /* 4. Parallax */
    var px = [];
    [['.hero__media', .22], ['.closing__lineup', -.07], ['.highlights__art', .06], ['.how__art', .05], ['.col-hero__img', .12]].forEach(function (d) {
      $$(d[0]).forEach(function (el) { el.setAttribute('data-parallax', d[1]); px.push({ el: el, k: d[1] }); });
    });
    var ticking = false;
    function para() {
      ticking = false; var h = window.innerHeight;
      px.forEach(function (o) {
        var r = o.el.getBoundingClientRect(); if (r.bottom < -100 || r.top > h + 100) return;
        var c = r.top + r.height / 2 - h / 2;
        o.el.style.translate = '0 ' + (-c * o.k).toFixed(1) + 'px';
      });
    }
    if (px.length) { para(); window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(para); } }, { passive: true }); }
    /* 5. Card tilt */
    if (!html.classList.contains('no-tilt') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mousemove', function (e) {
        var card = e.target.closest && e.target.closest('.product-card');
        if (initMotion.last && initMotion.last !== card) { initMotion.last.classList.remove('is-tilting'); var m0 = $('.product-card__media', initMotion.last); if (m0) m0.style.transform = ''; initMotion.last = null; }
        if (!card) return;
        var media = $('.product-card__media', card); if (!media) return;
        var r = media.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        if (y > .7) return;
        card.classList.add('is-tilting'); initMotion.last = card;
        media.style.transform = 'perspective(900px) rotateX(' + (-y * 7).toFixed(2) + 'deg) rotateY(' + (x * 9).toFixed(2) + 'deg)';
      }, { passive: true });
    }
  }

  /* Theme editor: re-run the in-view and section helpers when a section is re-rendered */
  document.addEventListener('shopify:section:load', function () { initInView(); initCounters(); initGap(); initKi(); initWishlist(); initAnnouncement(); initHx(); initFamilyLadder(); initReels(); initNeed(); initHabit(); initLab(); initAmbient(); initRoutine(); initNeedCheck(); /*v11*/ initHeroStage(); initGapJar(); initReelSwitch(); initFamilyKit(); initReviewSpotlight(); initClinicalIngredients(); initWhy(); initWeeks(); /*v11end*/ /*v10*/ initStory(); initTrust(); initHxFx(); initFlAuto(); /*v10end*/ });
  /* ==== v6 end ==== */

  /* ==== v7 start ==== */
  /* ---------- Home banners: numbered tabs, timed progress, word-by-word headlines, art that settles in ---------- */
  function splitHx(el) {
    var n = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var parts = c.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var o = document.createElement('span'), i = document.createElement('span');
            o.className = 'hx-w'; i.textContent = p; i.style.setProperty('--w', n++); o.appendChild(i); frag.appendChild(o);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1) walk(c);
      });
    })(el);
  }
  function initHx() {
    $$('[data-hx]').forEach(function (hx) {
      if (hx._hx) return; hx._hx = true;
      var slides = $$('.hx__slide', hx), tabs = $$('.hx__tab', hx);
      slides.forEach(function (s) { var t = $('.hx__title', s); if (t) splitHx(t); });
      var i = 0;
      if (!reduced) { slides[0].classList.remove('is-in'); requestAnimationFrame(function () { requestAnimationFrame(function () { slides[0].classList.add('is-in'); }); }); }
      if (slides.length < 2) return;
      var delay = (parseFloat(hx.getAttribute('data-delay')) || 7) * 1000, auto = hx.getAttribute('data-autoplay') !== 'false';
      var timer = 0, started = 0, remaining = delay, hover = false, visible = true;
      hx.style.setProperty('--hx-delay', delay / 1000 + 's');
      function restartBar() { var b = tabs[i] && $('.hx__tab-bar i', tabs[i]); if (b) { b.style.animation = 'none'; void b.offsetWidth; b.style.animation = ''; } }
      function stop() { if (timer) { clearTimeout(timer); timer = 0; remaining -= performance.now() - started; } }
      function run() {
        if (reduced || !auto || hover || !visible) { hx.classList.toggle('is-paused', auto && !reduced); return; }
        hx.classList.remove('is-paused'); hx.classList.add('is-playing');
        clearTimeout(timer); started = performance.now(); timer = setTimeout(function () { timer = 0; go(i + 1); }, Math.max(300, remaining));
      }
      function go(n, focus) {
        var prev = slides[i]; i = (n + slides.length) % slides.length; var next = slides[i];
        if (prev !== next) {
          prev.classList.remove('is-in'); prev.setAttribute('aria-hidden', 'true');
          $$('a, button', prev).forEach(function (a) { a.tabIndex = -1; });
          setTimeout(function () { if (prev !== slides[i]) prev.classList.remove('is-active'); }, 40);
          next.classList.add('is-active'); next.removeAttribute('aria-hidden');
          $$('a, button', next).forEach(function (a) { a.removeAttribute('tabindex'); });
          requestAnimationFrame(function () { requestAnimationFrame(function () { next.classList.add('is-in'); }); });
        }
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        if (focus && tabs[i]) tabs[i].focus();
        clearTimeout(timer); timer = 0; remaining = delay; restartBar(); run();
      }
      tabs.forEach(function (t, k) {
        on(t, 'click', function () { go(k); });
        on(t, 'keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (d) { e.preventDefault(); go(i + d, true); } });
      });
      on($('[data-hx-prev]', hx), 'click', function () { go(i - 1); });
      on($('[data-hx-next]', hx), 'click', function () { go(i + 1); });
      var frame = $('.hx__frame', hx);
      on(frame, 'mouseenter', function () { hover = true; stop(); hx.classList.add('is-paused'); });
      on(frame, 'mouseleave', function () { hover = false; run(); var a = $('.hx__slide.is-active .hx__art', hx); if (a) { a.style.setProperty('--mx', 0); a.style.setProperty('--my', 0); } });
      on(hx, 'focusin', function () { hover = true; stop(); hx.classList.add('is-paused'); });
      on(hx, 'focusout', function () { hover = false; run(); });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced) {
        on(frame, 'mousemove', function (e) {
          var r = frame.getBoundingClientRect(), a = $('.hx__slide.is-active .hx__art', hx); if (!a) return;
          a.style.setProperty('--mx', ((e.clientX - r.left) / r.width - .5).toFixed(3)); a.style.setProperty('--my', ((e.clientY - r.top) / r.height - .5).toFixed(3));
        });
      }
      var x0 = null, y0 = null;
      on(frame, 'touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      on(frame, 'touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1)); x0 = null;
      });
      document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (document.hidden) stop(); else run(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) run(); else { stop(); hx.classList.add('is-paused'); } }, { threshold: .25 }).observe(hx);
      }
      restartBar(); run();
    });
  }

  /* ---------- Family ladder: rungs climb in when the section arrives ---------- */
  function initFamilyLadder() {
    $$('[data-fl]').forEach(function (fl) {
      var lad = $('.fl__ladder', fl); if (!lad || lad._fl) return; lad._fl = true;
      if (reduced || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { lad.classList.add('is-in'); io.disconnect(); } }, { threshold: .3 });
      io.observe(lad);
    });
  }

  /* ---------- Reels: play on hover or when centred, open full screen with sound ---------- */
  var reelViewer = null;
  function reelVideo(r) { return r ? $('video', r) : null; }
  function reelPlay(r, sound) {
    var v = reelVideo(r); if (!v) return;
    v.muted = !sound; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () {});
    r.classList.add('is-playing');
  }
  function reelStop(r) { var v = reelVideo(r); if (!v) return; v.pause(); r.classList.remove('is-playing'); }
  function buildViewer() {
    var el = document.createElement('div');
    el.className = 'reel-viewer'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Video');
    var ic = function (name) { var b = $('.icon-' + name); return b ? b.outerHTML : ''; };
    el.innerHTML = '<div class="reel-viewer__stage"></div>' +
      '<button class="reel-viewer__btn reel-viewer__close" type="button" aria-label="Close"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button class="reel-viewer__btn reel-viewer__prev" type="button" aria-label="Previous"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg></button>' +
      '<button class="reel-viewer__btn reel-viewer__next" type="button" aria-label="Next"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>' +
      '<button class="reel-viewer__btn reel-viewer__sound" type="button" aria-label="Sound on or off" hidden><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9.5h4l5-4v13l-5-4H4z"/><path d="M16.5 9a4 4 0 0 1 0 6M19 6.5a7.5 7.5 0 0 1 0 11"/></svg></button>';
    document.body.appendChild(el);
    var stage = $('.reel-viewer__stage', el), list = [], idx = 0, cur = null, back = null;
    function show(n) {
      if (cur) reelStop(cur);
      idx = (n + list.length) % list.length; stage.innerHTML = '';
      cur = list[idx].cloneNode(true); cur.removeAttribute('data-reel'); cur.classList.remove('is-playing'); cur.style.removeProperty('--rp');
      stage.appendChild(cur);
      var v = reelVideo(cur); $('.reel-viewer__sound', el).hidden = !v;
      if (v) {
        v.currentTime = 0; reelPlay(cur, true);
        v.addEventListener('timeupdate', function () { if (v.duration) cur.style.setProperty('--rp', (v.currentTime / v.duration * 100) + '%'); });
        v.addEventListener('ended', function () { show(idx + 1); });
        on(v, 'click', function () { if (v.paused) reelPlay(cur, !v.muted); else reelStop(cur); });
      }
      $('.reel-viewer__prev', el).hidden = $('.reel-viewer__next', el).hidden = list.length < 2;
    }
    function close() {
      if (cur) reelStop(cur); el.classList.remove('is-open'); document.documentElement.style.overflow = '';
      setTimeout(function () { stage.innerHTML = ''; cur = null; }, 350); if (back) back.focus();
    }
    on($('.reel-viewer__close', el), 'click', close);
    on($('.reel-viewer__prev', el), 'click', function () { show(idx - 1); });
    on($('.reel-viewer__next', el), 'click', function () { show(idx + 1); });
    on($('.reel-viewer__sound', el), 'click', function () { var v = reelVideo(cur); if (v) v.muted = !v.muted; });
    on(el, 'click', function (e) { if (e.target === el) close(); });
    document.addEventListener('keydown', function (e) {
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(idx + 1); else if (e.key === 'ArrowLeft') show(idx - 1);
    });
    var ty = null;
    on(el, 'touchstart', function (e) { ty = e.touches[0].clientY; }, { passive: true });
    on(el, 'touchend', function (e) { if (ty === null) return; var d = e.changedTouches[0].clientY - ty; if (Math.abs(d) > 60) show(idx + (d < 0 ? 1 : -1)); ty = null; });
    return { open: function (l, n, from) { list = l; back = from || null; show(n); el.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; setTimeout(function () { $('.reel-viewer__close', el).focus(); }, 60); } };
  }
  function initReels() {
    $$('[data-reels]').forEach(function (rail) {
      if (rail._reels) return; rail._reels = true;
      var reels = $$('[data-reel]', rail), fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      reels.forEach(function (r, k) {
        var v = reelVideo(r);
        if (v) on(v, 'timeupdate', function () { if (v.duration) r.style.setProperty('--rp', (v.currentTime / v.duration * 100) + '%'); });
        if (fine && v) { on(r, 'mouseenter', function () { reelPlay(r); }); on(r, 'mouseleave', function () { reelStop(r); }); }
        var open = function (e) { if (e) e.preventDefault(); if (!reelViewer) reelViewer = buildViewer(); reels.forEach(reelStop); reelViewer.open(reels, k, $('[data-reel-open]', r)); };
        on($('[data-reel-open]', r), 'click', open);
        on($('.reel__media', r), 'click', function () { if (!rail.classList.contains('is-dragging')) open(); });
      });
      if (!fine && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.intersectionRatio > .8) reelPlay(e.target); else reelStop(e.target); }); }, { threshold: [0, .8, 1] });
        reels.forEach(function (r) { if (reelVideo(r)) io.observe(r); });
      }
    });
  }

  /* ---------- When you need us: the two sides arrive one after the other ---------- */
  function initNeed() {
    $$('[data-need]').forEach(function (n) {
      if (n._need) return; n._need = true;
      if (reduced || !('IntersectionObserver' in window)) { n.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { n.classList.add('is-in'); io.disconnect(); } }, { threshold: .25 });
      io.observe(n);
    });
  }

  /* ---------- How it works: the daily habit. Tablets: today's lid on a 7-day organiser opens and the tablet is taken.
     Powders: one scoop from the tub into milk, stirred (or shaken) until it turns the drink colour. One day ticked off each time. ---------- */
  function initHabit() {
    $$('[data-habit]').forEach(function (demo) {
      if (demo._habit) return; demo._habit = true;
      var sec = demo.closest('.habit'), mode = demo.getAttribute('data-mode'), vessel = demo.getAttribute('data-vessel');
      var days = $$('.habit__grid span', demo), count = $('[data-habit-day]', demo), d = 0, timers = [], running = false;
      function later(fn, ms) { timers.push(setTimeout(function () { if (running) fn(); }, ms)); }
      function clear() { timers.forEach(clearTimeout); timers = []; }
      function mark(n) { days.forEach(function (x, k) { x.classList.toggle('is-done', k < n); x.classList.remove('is-today'); }); if (days[n - 1]) days[n - 1].classList.add('is-today'); if (count) count.textContent = Math.max(1, n); }
      function tickDay() { d++; if (d > days.length) d = 1; mark(d); }
      /* tablets */
      var cells = $$('.pillbox__cell', demo), week = $('[data-habit-week] b', demo), pop = $('[data-habit-pop]', demo), bottle = $('.habit__bottle', demo), w = 1;
      function newWeek() {
        cells.forEach(function (c, i) { setTimeout(function () { c.classList.remove('is-open', 'is-taken'); c.classList.add('is-refill'); setTimeout(function () { c.classList.remove('is-refill'); }, 600); }, i * 70); });
        if (bottle) { bottle.classList.remove('is-pour'); void bottle.offsetWidth; bottle.classList.add('is-pour'); }
        w = d >= days.length ? 1 : w + 1; if (week) week.textContent = w;
      }
      function tabletDay() {
        var i = d % 7;
        if (i === 0 && d > 0) { newWeek(); later(tabletDay, 900); return; }
        var c = cells[i]; if (!c) return;
        c.classList.add('is-open');
        later(function () {
          c.classList.add('is-taken');
          if (pop) { var r = c.getBoundingClientRect(), s = pop.parentNode.getBoundingClientRect(); pop.style.left = (r.left - s.left + r.width / 2) + 'px'; pop.style.top = (r.top - s.top) + 'px'; pop.classList.remove('is-on'); void pop.offsetWidth; pop.classList.add('is-on'); }
          tickDay();
        }, 520);
        later(tabletDay, d < 4 ? 1900 : 1500);
      }
      /* powders */
      var scoop = $('[data-habit-scoop]', demo), cup = $('[data-habit-vessel]', demo), tub = $('[data-habit-tub]', demo), scene = $('.habit__scene', demo);
      function geo() {
        if (!scene || !scoop || !cup) return null;
        var s = scene.getBoundingClientRect(), c = cup.getBoundingClientRect(), t = tub ? tub.getBoundingClientRect() : { left: s.left + 30, top: s.top + 60, width: 90, height: 120 }, sc = scoop.getBoundingClientRect();
        var mouthY = vessel === 'shaker' ? c.top + c.height * .2 : c.top + c.height * .06;
        return { x0: t.left - s.left + t.width * .5 - sc.width * .42, y0: t.top - s.top + t.height * .08, x1: c.left - s.left + c.width * .5 - sc.width * .2, y1: mouthY - s.top - sc.height * 1.05 };
      }
      function place(x, y, r, ms) { scoop.style.transition = ms ? 'transform ' + ms + 'ms cubic-bezier(.45,.05,.25,1), opacity .3s' : 'none'; scoop.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + r + 'deg)'; }
      function powderDay() {
        var g = geo(); if (!g) return;
        demo.classList.remove('is-mixed', 'is-ready', 'is-pour', 'is-stir', 'is-capped');
        scoop.classList.remove('is-empty'); place(g.x0, g.y0 + 46, -8, 0); scoop.style.opacity = 0;
        void scoop.offsetWidth;
        scoop.style.opacity = 1; place(g.x0, g.y0 - 30, -14, 520);
        later(function () { place(g.x1, g.y1, -6, 760); }, 560);
        later(function () { place(g.x1 + 6, g.y1 + 4, -112, 380); }, 1360);
        later(function () { demo.classList.add('is-pour'); scoop.classList.add('is-empty'); }, 1520);
        later(function () { place(g.x0, g.y0 - 10, -10, 640); scoop.style.opacity = 0; }, 2150);
        later(function () { demo.classList.add('is-stir'); if (vessel === 'shaker') demo.classList.add('is-capped'); }, 2250);
        later(function () { demo.classList.add('is-mixed'); }, 2450);
        later(function () { demo.classList.remove('is-stir'); demo.classList.add('is-ready'); tickDay(); }, 3450);
        later(powderDay, d < 4 ? 5000 : 4300);
      }
      function start() { running = true; if (mode === 'tablet') later(tabletDay, 600); else later(powderDay, 500); }
      function stop() { running = false; clear(); }
      if (reduced || !('IntersectionObserver' in window)) {
        if (sec) sec.classList.add('is-in'); mark(12);
        if (mode === 'tablet') cells.slice(0, 5).forEach(function (c) { c.classList.add('is-open', 'is-taken'); });
        else demo.classList.add('is-mixed', 'is-ready');
        return;
      }
      document.addEventListener('uv:variant', function (e) {
        var v = e.detail && e.detail.variant; if (!v || !sec) return;
        var t = (v.title || '').toLowerCase();
        sec.style.setProperty('--drink', /unflav|plain/.test(t) ? 'var(--plain)' : 'var(--cocoa)');
        var img = $('img', tub || bottle || demo), src = v.featured_image && v.featured_image.src;
        var pk = e.detail.pack; if (img && pk) { img.removeAttribute('srcset'); img.src = pk; }
      });
      new IntersectionObserver(function (es) {
        var vis = es[0].isIntersecting;
        if (vis && sec) sec.classList.add('is-in');
        if (vis && !running) start(); else if (!vis && running) stop();
      }, { threshold: .35 }).observe(demo);
    });
  }

  /* ==== v7 end ==== */

  /* ==== v8 start ==== */
  /* ---------- Lab pass: the pass is scanned as it comes into view; the window plays the tour.
     With no video yet, 'Start the tour' walks the illustrated floor chapter by chapter. ---------- */
  function initLab() {
    $$('[data-lab]').forEach(function (lab) {
      if (lab._lab) return; lab._lab = true;
      var pass = $('[data-lab-pass]', lab), film = $('[data-lab-film]', lab), play = $('[data-lab-play]', lab), soon = $('[data-lab-soon]', lab);
      var video = $('video', film), tpl = $('template[data-lab-embed]', lab), chapters = $$('.lab__chapter', lab), tour = 0, step = -1;
      function setActive(i, prog) {
        chapters.forEach(function (c, k) { c.classList.toggle('is-active', k === i); c.classList.toggle('is-past', k < i); });
        if (film) film.setAttribute('data-ch', i < 0 ? '' : i % 5);
        var cap = $('[data-lab-cap]', lab), c = chapters[i]; if (cap && c && cap._i !== i) { cap._i = i; cap.textContent = ($('b', c) || c).textContent; cap.classList.remove('is-on'); void cap.offsetWidth; cap.classList.add('is-on'); }
        if (cap && i < 0) { cap._i = -1; cap.classList.remove('is-on'); }
        if (prog !== undefined && chapters[i]) chapters[i].style.setProperty('--cp', prog);
      }
      function storyboard(from) {
        clearInterval(tour); step = from || 0; film.classList.add('is-touring');
        if (soon) soon.hidden = false;
        var t0 = performance.now(), each = 2600;
        setActive(step, 0);
        tour = setInterval(function () {
          var u = (performance.now() - t0) / each;
          if (u >= 1) { step++; t0 = performance.now(); u = 0; if (step >= chapters.length) { clearInterval(tour); film.classList.remove('is-touring'); setActive(-1); chapters.forEach(function (c) { c.classList.remove('is-past'); c.style.removeProperty('--cp'); }); return; } }
          setActive(step, u.toFixed(3));
        }, 60);
      }
      function begin(i) {
        var t = chapters[i] ? parseFloat(chapters[i].getAttribute('data-t')) || 0 : 0;
        if (video) {
          film.classList.add('is-playing');
          try { video.currentTime = t; } catch (e) {}
          var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (tpl) {
          film.classList.add('is-playing');
          if (!$('iframe', film)) film.appendChild(tpl.content.cloneNode(true));
        } else storyboard(i);
      }
      on(play, 'click', function () { begin(0); });
      chapters.forEach(function (c, i) { on(c, 'click', function () { begin(i); }); });
      if (video) {
        on(video, 'timeupdate', function () {
          var t = video.currentTime, idx = 0;
          chapters.forEach(function (c, k) { if (t >= (parseFloat(c.getAttribute('data-t')) || 0)) idx = k; });
          var a = parseFloat(chapters[idx] && chapters[idx].getAttribute('data-t')) || 0, b = chapters[idx + 1] ? parseFloat(chapters[idx + 1].getAttribute('data-t')) : (video.duration || a + 1);
          setActive(idx, Math.max(0, Math.min(1, (t - a) / Math.max(1, b - a))).toFixed(3));
        });
        on(video, 'pause', function () { if (video.currentTime < .2) film.classList.remove('is-playing'); });
      }
      /* the pass tilts toward the pointer */
      if (pass && window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced) {
        on(pass, 'pointermove', function (e) { var r = pass.getBoundingClientRect(); pass.style.setProperty('--rx', ((e.clientY - r.top) / r.height - .5).toFixed(3)); pass.style.setProperty('--ry', ((e.clientX - r.left) / r.width - .5).toFixed(3)); });
        on(pass, 'pointerleave', function () { pass.style.setProperty('--rx', 0); pass.style.setProperty('--ry', 0); });
      }
      if (reduced || !('IntersectionObserver' in window)) { lab.classList.add('is-in', 'is-granted'); return; }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        lab.classList.add('is-in'); setTimeout(function () { lab.classList.add('is-granted'); }, 1500);
      }, { threshold: .3 });
      io.observe(lab);
    });
  }

  /* ---------- Ambient: the page background drifts slowly with the scroll, so sections read as one surface ---------- */
  function initAmbient() {
    if (reduced || document.documentElement._amb) return; document.documentElement._amb = true;
    var tick = false, root = document.documentElement;
    function upd() { var h = Math.max(1, root.scrollHeight - window.innerHeight); root.style.setProperty('--sy', (window.scrollY / h).toFixed(4)); tick = false; }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }
  /* ==== v8 end ==== */









  /* ==== v9 start ==== */
  /* ---------- Build your routine: tick who's at home, one formula each, add it all in one tap ---------- */
  function gjCountMoney(el, to, fmt) {
    if (!el) return;
    var from = el._v || 0; el._v = to; cancelAnimationFrame(el._raf);
    if (reduced || from === to) { el.textContent = fmt(to); return; }
    var t0 = performance.now(), d = 450;
    (function f(t) { var q = Math.min(1, (t - t0) / d); q = 1 - Math.pow(1 - q, 3); el.textContent = fmt(Math.round((from + (to - from) * q) / 100) * 100); if (q < 1) el._raf = requestAnimationFrame(f); })(t0);
  }
  function initRoutine() {
    $$('[data-rb]').forEach(function (rb) {
      if (rb._rb) return; rb._rb = true;
      var tiles = $$('[data-rb-tile]', rb), lines = $('[data-rb-lines]', rb), empty = $('[data-rb-empty]', rb), count = $('[data-rb-count]', rb);
      var total = $('[data-rb-total]', rb), add = $('[data-rb-add]', rb);
      var zero = count ? count.textContent : '', one = rb.getAttribute('data-one') || '1', other = rb.getAttribute('data-other') || '[n]';
      var fmt = theme.formatMoney || function (c) { return '₹' + Math.round(c / 100); };
      function picked() { return tiles.filter(function (t) { return t.classList.contains('is-on'); }); }
      function qty(t) { return parseInt($('[data-rb-n]', t).textContent, 10) || 1; }
      function render() {
        var sel = picked(), people = 0, full = 0;
        lines.innerHTML = '';
        sel.forEach(function (t) {
          var q = qty(t), price = +t.getAttribute('data-price');
          people += q; full += price * q;
          var li = document.createElement('li'); li.className = 'rb__line';
          var img = t.getAttribute('data-img');
          li.innerHTML = (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
            '<span class="rb__line-copy"><b></b><small></small></span><span class="rb__line-price"></span>';
          $('b', li).textContent = t.getAttribute('data-label') + (q > 1 ? ' × ' + q : '');
          $('small', li).textContent = t.getAttribute('data-title');
          $('.rb__line-price', li).textContent = fmt(price * q);
          lines.appendChild(li);
        });
        gjCountMoney(total, full, fmt);
        empty.hidden = sel.length > 0;
        count.textContent = people === 0 ? zero : (people === 1 ? one : other.replace('[n]', people));
        add.disabled = sel.length === 0;
        rb.classList.toggle('has-items', sel.length > 0);
      }
      tiles.forEach(function (t) {
        var pick = $('[data-rb-pick]', t), q = $('[data-rb-qty]', t), n = $('[data-rb-n]', t);
        on(pick, 'click', function () {
          var onNow = !t.classList.contains('is-on');
          t.classList.toggle('is-on', onNow); pick.setAttribute('aria-pressed', onNow ? 'true' : 'false'); q.hidden = !onNow;
          if (onNow) { n.textContent = '1'; t.classList.remove('is-pop'); void t.offsetWidth; t.classList.add('is-pop'); }
          render();
        });
        on($('[data-rb-plus]', t), 'click', function () { n.textContent = Math.min(9, qty(t) + 1); render(); });
        on($('[data-rb-minus]', t), 'click', function () {
          var v = qty(t) - 1;
          if (v < 1) { t.classList.remove('is-on'); pick.setAttribute('aria-pressed', 'false'); q.hidden = true; n.textContent = '1'; } else n.textContent = v;
          render();
        });
      });
      $$('[data-rb-filter]', rb).forEach(function (f) {
        on(f, 'click', function () {
          var g = f.getAttribute('data-rb-filter');
          $$('[data-rb-filter]', rb).forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
          tiles.forEach(function (t) { t.hidden = g !== 'all' && t.getAttribute('data-group') !== g; });
        });
      });
      on(add, 'click', function () {
        var items = picked().map(function (t) { return { id: +t.getAttribute('data-id'), quantity: qty(t) }; });
        if (!items.length) return;
        if (theme.addItems) theme.addItems({ items: items }, add);
        else fetch((theme.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function () { location.href = theme.routes.cart || '/cart'; });
      });
      render();
    });
  }

  /* ---------- Honesty check: tap what's true; all of it true means you don't need us ---------- */
  function initNeedCheck() {
    $$('[data-need-check-root]').forEach(function (root) {
      if (root._nc) return; root._nc = true;
      var ticks = $$('[data-need-tick]', root), v = $('[data-need-verdict]', root);
      if (!v) return;
      var total = ticks.length, touched = false;
      function say() {
        var n = ticks.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; }).length;
        var key = !touched ? 'start' : (n === 0 ? 'none' : (n === total ? 'all' : 'some'));
        v.textContent = (v.getAttribute('data-' + key) || '').replace('[n]', n).replace('[total]', total);
        root.setAttribute('data-verdict', key);
        v.classList.remove('is-bump'); void v.offsetWidth; v.classList.add('is-bump');
      }
      ticks.forEach(function (t) {
        on(t, 'click', function () { touched = true; t.setAttribute('aria-pressed', t.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); say(); });
      });
    });
  }
  /* ==== v9 end ==== */































  /* ==== v10 start ==== */
  // init: initStory
  /* ---------- Story: chapters from Section design -> Story, a side bar, chapter numbers, a page glow per chapter ---------- */
  function initStory() {
    if (document.documentElement._story) return;
    var cfg = (window.theme && theme.story) || {}; function yes(k) { return cfg[k] !== false; }
    if (!yes('on')) return;
    var marks = $$('.story-mark'); if (marks.length < 2) return;
    document.documentElement._story = true;
    var chapters = marks.map(function (m) {
      var sec = m.closest('.shopify-section') || m.parentElement, raw = m.getAttribute('data-story') || '', parts = raw.split('|');
      var num = parts.length > 1 ? parts[0].trim() : '', label = (parts.length > 1 ? parts.slice(1).join('|') : parts[0]).trim();
      if (!sec.id) sec.id = 'story-' + Math.random().toString(36).slice(2, 8);
      sec.classList.add('has-story');
      var eb = $('.eyebrow, .need2__eyebrow', sec);
      if (yes('numbers') && eb && num && !$('.story-n', eb)) { var n = document.createElement('span'); n.className = 'story-n'; n.textContent = num; eb.insertBefore(n, eb.firstChild); }
      return { sec: sec, num: num, label: label, tint: m.getAttribute('data-tint') || '' };
    });
    chapters.forEach(function (c, i) {
      var nx = chapters[i + 1]; if (!nx || !yes('next')) return;
      var a = document.createElement('a'); a.className = 'story-next'; a.href = '#' + nx.sec.id;
      a.innerHTML = '<i aria-hidden="true"></i><span><small></small><b></b></span>';
      $('small', a).textContent = cfg.nextLabel || 'Next';
      $('b', a).textContent = (nx.num ? nx.num + ' · ' : '') + nx.label;
      c.sec.appendChild(a);
    });
    var rail = document.createElement('nav'); rail.className = 'story-rail'; rail.setAttribute('aria-label', cfg.railLabel || 'Story'); if (!yes('rail')) rail.hidden = true;
    var html = '<span class="story-rail__line" aria-hidden="true"><i></i></span><ol>';
    chapters.forEach(function (c, i) { html += '<li><a href="#' + c.sec.id + '" data-i="' + i + '"><span class="story-rail__dot" aria-hidden="true"></span><span class="story-rail__n">' + (c.num || '') + '</span><span class="story-rail__label"></span></a></li>'; });
    rail.innerHTML = html + '</ol>';
    $$('.story-rail__label', rail).forEach(function (l, i) { l.textContent = chapters[i].label; });
    document.body.appendChild(rail);
    var links = $$('a', rail), fill = $('.story-rail__line i', rail), root = document.documentElement, cur = -1;
    function setActive(i) {
      if (i === cur) return; cur = i;
      links.forEach(function (l, j) { l.classList.toggle('is-active', j === i); l.classList.toggle('is-past', j < i); if (j === i) l.setAttribute('aria-current', 'step'); else l.removeAttribute('aria-current'); });
      var t = i >= 0 && yes('glow') ? chapters[i].tint : ''; root.style.setProperty('--story-tint', t || 'transparent');
      rail.classList.toggle('is-on', i >= 0);
    }
    var tick = false;
    function upd() {
      tick = false; var mid = window.innerHeight * .45, act = -1;
      chapters.forEach(function (c, i) { var r = c.sec.getBoundingClientRect(); if (r.top <= mid && r.bottom > mid) act = i; });
      setActive(act);
      var first = chapters[0].sec.getBoundingClientRect(), last = chapters[chapters.length - 1].sec.getBoundingClientRect();
      var span = Math.max(1, last.bottom - first.top), p = Math.min(1, Math.max(0, (mid - first.top) / span));
      fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  // init: initTrust
  /* ---------- v10 helpers ---------- */
  function onceInView(el, fn, threshold) {
    if (!el) return;
    if (reduced || !('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, { threshold: threshold || .25 });
    io.observe(el);
  }
  /* ---------- Behind the label: partners rise, the impact line draws ---------- */
  function initTrust() {
    $$('[data-trust]').forEach(function (t) {
      if (t._tr) return; t._tr = true;
      onceInView(t, function () { t.classList.add('is-in'); }, .2);
    });
  }

  // init: initHxFx
  /* ---------- Banner: the floating nutrients lean toward the pointer ---------- */
  function initHxFx() {
    $$('.hx--single').forEach(function (hx) {
      var fx = $('.hx-fx', hx); if (!fx || fx._p || reduced) return; fx._p = true;
      if (!window.matchMedia('(hover: hover)').matches) return;
      var raf = 0, mx = 0, my = 0;
      on(hx, 'pointermove', function (e) {
        var r = hx.getBoundingClientRect(); mx = ((e.clientX - r.left) / r.width - .5) * 2; my = ((e.clientY - r.top) / r.height - .5) * 2;
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; fx.style.setProperty('--mx', mx.toFixed(3)); fx.style.setProperty('--my', my.toFixed(3)); });
      });
      on(hx, 'pointerleave', function () { fx.style.setProperty('--mx', 0); fx.style.setProperty('--my', 0); });
    });
  }

  // init: initFlAuto
  /* ---------- Family ladder: climbs a step every few seconds until the shopper takes over ---------- */
  function initFlAuto() {
    $$('[data-fl-auto]').forEach(function (fl) {
      if (fl._auto || reduced) return; fl._auto = true;
      var rungs = $$('.fl__rung', fl), timer = null, stopped = false, visible = false, hover = false, D = 5200;
      if (rungs.length < 2) return;
      function cur() { for (var i = 0; i < rungs.length; i++) if (rungs[i].getAttribute('aria-selected') === 'true') return i; return 0; }
      function arm() {
        clearTimeout(timer); fl.classList.remove('is-auto');
        if (stopped || !visible || hover) return;
        void fl.offsetWidth; fl.classList.add('is-auto');
        timer = setTimeout(function () { rungs[(cur() + 1) % rungs.length].click(); arm(); }, D);
      }
      function stop(e) { if (e && e.isTrusted === false) return; stopped = true; clearTimeout(timer); fl.classList.remove('is-auto'); }
      on(fl, 'pointerdown', stop); on(fl, 'keydown', stop);
      on(fl, 'mouseenter', function () { hover = true; arm(); });
      on(fl, 'mouseleave', function () { hover = false; arm(); });
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; arm(); }); }, { threshold: .45 }).observe(fl);
    });
  }

  /* ==== v10 end ==== */





















































































  /* ==== v11 start ==== */
  // init: initHeroStage
  /* ---------- Hero, product stage: one life stage at a time, moving on by itself ---------- */
  function initHeroStage() {
    $$('[data-hs]').forEach(function (hs) {
      if (hs._hs) return; hs._hs = true;
      var scenes = $$('[data-hs-scene]', hs), tabs = $$('.hs__tab', hs), cur = 0, timer = null, hover = false, visible = true;
      if (!scenes.length) return; /* one-banner line-up: CSS only */
      var delay = (parseInt(hs.getAttribute('data-delay'), 10) || 6) * 1000, auto = hs.getAttribute('data-autoplay') === 'true' && !reduced && scenes.length > 1;
      hs.style.setProperty('--hs-delay', (delay / 1000) + 's');
      function tint(i) { var t = getComputedStyle(scenes[i]).getPropertyValue('--hs-tint').trim(); if (t) hs.style.setProperty('--hs-tint-live', t); }
      function show(i, focus) {
        i = (i + scenes.length) % scenes.length; if (i === cur && scenes[i].classList.contains('is-active')) { arm(); return; }
        scenes.forEach(function (s, j) {
          var on = j === i; s.classList.toggle('is-active', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
          $$('a', s).forEach(function (a) { a.tabIndex = on ? 0 : -1; });
        });
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        cur = i; tint(i); if (focus && tabs[i]) tabs[i].focus(); arm();
      }
      function arm() {
        clearTimeout(timer); hs.classList.remove('is-auto');
        if (!auto || hover || !visible) return;
        void hs.offsetWidth; hs.classList.add('is-auto');
        timer = setTimeout(function () { show(cur + 1); }, delay);
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { show(i); });
        on(t, 'keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1, true); } else if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1, true); }
        });
      });
      var stage = $('[data-hs-stage]', hs);
      on(stage, 'mouseenter', function () { hover = true; arm(); });
      on(stage, 'mouseleave', function () { hover = false; arm(); });
      on(stage, 'focusin', function () { hover = true; arm(); });
      on(stage, 'focusout', function () { hover = false; arm(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; arm(); }, { threshold: .25 }).observe(hs);
      tint(0); arm();
    });
  }

  // init: initGapJar
  /* ---------- Nutrition gap (v11): pick a formula, its cap comes off, a scoop or tablet comes out of the pack and fills the gap ---------- */
  function gjCount(el, to) {
    if (!el) return;
    var from = parseInt(el.textContent, 10) || 0;
    cancelAnimationFrame(el._raf); clearTimeout(el._to);
    if (reduced || from === to) { el.textContent = to; return; }
    var t0 = performance.now(), d = 520;
    el._to = setTimeout(function () { cancelAnimationFrame(el._raf); el.textContent = to; }, d + 80);
    (function f(t) { var q = Math.min(1, (t - t0) / d); q = 1 - Math.pow(1 - q, 3); el.textContent = Math.round(from + (to - from) * q); if (q < 1) el._raf = requestAnimationFrame(f); })(t0);
  }
  function gjBox(el, stage) { var a = el.getBoundingClientRect(), b = stage.getBoundingClientRect(); return { x: a.left - b.left, y: a.top - b.top, w: a.width, h: a.height }; }
  function gjAnim(el, frames, ms, ease) {
    if (!el || !el.animate) return null;
    try { return el.animate(frames, { duration: Math.max(1, ms), easing: ease || 'cubic-bezier(.45,.05,.3,1)', fill: 'forwards' }); } catch (e) { return null; }
  }
  /* Open-pack shape: the cap and the body share one curved line (the front of the cap's rim), and the opening is drawn
     on that same ellipse, so the pack opens cleanly. Values are shares of the pack image: cap = where the cap ends,
     mw = width of the opening (tubs) or of the shoulder (bottles). */
  var GJ_NECK = .042;
  function gjOpenShape(p, shape, cap, mw, asp) {
    var ratio = shape === 'bottle' ? .17 : .1, e = ratio * mw * asp / 2, N = 16, curve = [], i;
    for (i = 0; i <= N; i++) { var x = .5 - mw / 2 + mw * i / N, t = (x - .5) / (mw / 2); curve.push([x, cap + e * Math.sqrt(Math.max(0, 1 - t * t))]); }
    var f = function (q) { return (q[0] * 100).toFixed(2) + '% ' + (q[1] * 100).toFixed(2) + '%'; }, c = (cap * 100).toFixed(2) + '%';
    var body = ['-30% 140%', '-30% ' + c].concat(curve.map(f), ['130% ' + c, '130% 140%']);
    var top = ['-30% -60%', '130% -60%', '130% ' + c].concat(curve.slice().reverse().map(f), ['-30% ' + c]);
    var b = $('.gj__body img', p), k = $('[data-gj-cap] img', p);
    if (b) b.style.clipPath = 'polygon(' + body.join(',') + ')';
    if (k) k.style.clipPath = 'polygon(' + top.join(',') + ')';
    p.style.setProperty('--e', e.toFixed(4));
  }
  function initGapJar() {
    $$('[data-gj]').forEach(function (root) {
      if (root._gj) return; root._gj = true;
      var panels = $$('[data-gj-panel]', root), tabs = $$('.gj__tab', root), sw = $('[data-gj-switch]', root);
      var speed = (parseFloat(root.getAttribute('data-speed')) || 100) / 100, auto = root.getAttribute('data-autoplay') === 'true';
      var food = parseFloat(getComputedStyle(root).getPropertyValue('--food')) || 70, seen = false;
      function T(ms) { return reduced ? 0 : Math.round(ms / speed); }
      function active() { return panels.filter(function (p) { return !p.hidden; })[0] || panels[0]; }
      function S(p) { return p._s || (p._s = { k: 0, busy: false, anims: [], timers: [], capOff: false }); }
      function later(p, fn, ms) { S(p).timers.push(setTimeout(fn, ms)); }
      function slices(p) { return $$('[data-gj-slice]', p); }
      function setK(p, k) {
        var sl = slices(p), rows = $$('[data-gj-row]', p), n = sl.length || 1;
        sl.forEach(function (x, i) { x.classList.toggle('is-on', i < k); });
        rows.forEach(function (x, i) { x.classList.toggle('is-on', i < k); });
        p.style.setProperty('--lvl', (k / n).toFixed(3));
        var c = $('[data-gj-count]', p); if (c) c.textContent = k;
        gjCount($('[data-gj-total]', p), Math.round(food + (100 - food) * k / n));
        S(p).k = k;
      }
      function syncSwitch() { if (!sw) return; var p = active(), s = S(p); sw.setAttribute('aria-pressed', s.k > 0 && s.k >= slices(p).length ? 'true' : 'false'); }
      function stopMotion(p) {
        var s = S(p);
        s.timers.forEach(clearTimeout); s.timers = [];
        s.anims.forEach(function (a) { try { a.cancel(); } catch (e) {} }); s.anims = [];
        var st = $('[data-gj-stream]', p); if (st) st.classList.remove('is-on');
        var sc = $('[data-gj-scoop]', p); if (sc) sc.classList.remove('is-full', 'is-out');
        var dr = $('[data-gj-drop]', p); if (dr) dr.classList.remove('is-out');
        p.classList.remove('is-open'); s.capOff = false;
      }
      /* ---- the product picker ---- */
      function choose(p, btn) {
        if (!btn) return;
        $$('[data-gj-pick]', p).forEach(function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var src = btn.getAttribute('data-img');
        $$('[data-gj-img]', p).forEach(function (im) { if (src && im.getAttribute('src') !== src) { im.setAttribute('src', src); im.loading = 'eager'; } });
        var cs = getComputedStyle(btn), fill = cs.getPropertyValue('--pick-fill').trim() || cs.getPropertyValue('--p-label').trim() || '#2D6A4F';
        ['--p-label', '--p-deep', '--p-tint', '--p-tint2'].forEach(function (v) { var x = cs.getPropertyValue(v).trim(); if (x) p.style.setProperty(v, x); });
        p.style.setProperty('--fill', fill);
        var mode = btn.getAttribute('data-mode') || 'tablet', shape = btn.getAttribute('data-shape') || (mode === 'tablet' ? 'bottle' : 'tub');
        var cap = parseFloat(btn.getAttribute('data-cap')) || (shape === 'bottle' ? .23 : .16);
        var mw = parseFloat(btn.getAttribute('data-mw')) || (btn.getAttribute('data-mouth') ? parseFloat(btn.getAttribute('data-mouth')) / 100 : (shape === 'bottle' ? .8 : .92));
        p.style.setProperty('--cap', cap); p.style.setProperty('--mw', mw);
        p.setAttribute('data-mode', mode); p.setAttribute('data-shape', shape);
        var body = $('.gj__body img', p);
        var shapeIt = function () { gjOpenShape(p, shape, cap, mw, body && body.naturalWidth ? body.naturalWidth / body.naturalHeight : (shape === 'bottle' ? .5 : .64)); };
        shapeIt(); if (body && !body.complete) body.addEventListener('load', shapeIt, { once: true });
        p.classList.toggle('gj__panel--light', btn.getAttribute('data-light') === '1');
        var t = $('[data-gj-buy-title]', p); if (t) t.textContent = btn.getAttribute('data-title') || '';
        var pr = $('[data-gj-buy-price]', p); if (pr) pr.textContent = btn.getAttribute('data-price') ? ' · ' + btn.getAttribute('data-price') : '';
        var add = $('[data-gj-add]', p); if (add) add.setAttribute('data-id', btn.getAttribute('data-id') || '');
        S(p).pick = btn;
      }
      function geometry(p) {
        var stage = $('[data-gj-stage]', p), jar = $('[data-gj-jar]', p), pack = $('[data-gj-pack]', p);
        var J = gjBox(jar, stage), P = gjBox(pack, stage), n = slices(p).length || 1;
        var cap = parseFloat(p.style.getPropertyValue('--cap')) || .15, mouthW = parseFloat(p.style.getPropertyValue('--mw')) || .8;
        var neck = p.getAttribute('data-shape') === 'bottle' ? GJ_NECK : 0;
        var insideTop = J.y + 12, insideH = J.h - 18;
        function surf(k) { return insideTop + insideH * (1 - (food + (100 - food) * k / n) / 100); }
        return { stage: stage, J: J, P: P, cap: cap, mx: P.x + P.w / 2, my: P.y + P.h * (cap - neck), mw: P.w * mouthW * (neck ? .62 : 1), jx: J.x + J.w / 2, jy: J.y + 2, surf: surf, n: n };
      }
      function capRest(g) {
        var capH = g.P.h * g.cap;
        var narrow = g.P.w < g.P.h * .55;
        return { dx: -g.P.w * (narrow ? .2 : .06), dy: -(capH * (narrow ? 1.05 : 1.6) + Math.max(18, g.P.h * .07)), up: -Math.max(14, capH * .45), rot: narrow ? -12 : -8 };
      }
      function capOff(p, g) {
        var c = $('[data-gj-cap]', p), s = S(p); if (!c || s.capOff) return 0;
        s.capOff = true;
        var r = capRest(g), bottle = p.getAttribute('data-shape') === 'bottle';
        var end = 'translate(' + r.dx + 'px,' + r.dy + 'px) rotate(' + r.rot + 'deg)';
        var frames = bottle
          ? [{ transform: 'none' }, { transform: 'rotate(-7deg)', offset: .12 }, { transform: 'rotate(6deg)', offset: .26 }, { transform: 'translateY(-3px) rotate(-6deg)', offset: .4 }, { transform: 'translateY(' + r.up + 'px) rotate(-2deg)', offset: .62 }, { transform: end }]
          : [{ transform: 'none' }, { transform: 'translateY(-2px) rotate(-2deg)', offset: .18 }, { transform: 'translateY(' + r.up + 'px) rotate(-3deg)', offset: .5 }, { transform: end }];
        var ms = T(bottle ? 1100 : 860);
        s.anims.push(gjAnim(c, frames, ms, 'cubic-bezier(.45,.05,.3,1)'));
        later(p, function () { p.classList.add('is-open'); }, Math.round(ms * (bottle ? .5 : .32)));
        return ms - T(60);
      }
      function capOn(p, g, delay) {
        var c = $('[data-gj-cap]', p), s = S(p); if (!c) return;
        later(p, function () {
          var r = capRest(g), bottle = p.getAttribute('data-shape') === 'bottle';
          var frames = [{ transform: 'translate(' + r.dx + 'px,' + r.dy + 'px) rotate(' + r.rot + 'deg)' }, { transform: 'translateY(' + r.up + 'px) rotate(-2deg)', offset: .45 }, { transform: 'translateY(-2px) rotate(' + (bottle ? 5 : 0) + 'deg)', offset: .78 }, { transform: 'none' }];
          s.anims.push(gjAnim(c, frames, T(820), 'cubic-bezier(.4,.1,.3,1)'));
          later(p, function () { p.classList.remove('is-open'); }, T(520));
          later(p, function () { s.capOff = false; }, T(840));
        }, delay);
      }
      function stream(p, x, top, bottom) {
        var st = $('[data-gj-stream]', p); if (!st) return;
        st.style.left = (x - 9) + 'px'; st.style.top = top + 'px'; st.style.height = Math.max(20, bottom - top) + 'px';
        st.style.setProperty('--fall', Math.max(20, bottom - top) + 'px'); st.classList.add('is-on');
      }
      function splash(p, g, k) {
        var sp = $('[data-gj-splash]', p); if (!sp || reduced) return;
        sp.style.left = (g.jx - 30) + 'px'; sp.style.top = (g.surf(k) - 8) + 'px';
        sp.classList.remove('is-on'); void sp.offsetWidth; sp.classList.add('is-on');
      }
      /* returns ms until the gap starts filling */
      function pourIn(p, g, fillMs) {
        var s = S(p), mode = p.getAttribute('data-mode');
        if (reduced) return 0;
        var t0 = capOff(p, g);
        if (mode === 'powder') {
          var sc = $('[data-gj-scoop]', p); if (!sc) return t0;
          var w = sc.offsetWidth || 84, h = sc.offsetHeight || 46;
          var inT = 'translate(' + (g.mx - w * .3) + 'px,' + (g.my - h * .2) + 'px) rotate(18deg)';
          var outT = 'translate(' + (g.mx - w * .3) + 'px,' + (g.my - h - 46) + 'px) rotate(0deg)';
          var over = 'translate(' + (g.jx - w * .3) + 'px,' + (g.J.y - h - 54) + 'px) rotate(0deg)';
          var tip = 'translate(' + (g.jx - w * .3) + 'px,' + (g.J.y - h - 54) + 'px) rotate(-70deg)';
          var a1 = T(520), a2 = T(560), a3 = T(300);
          later(p, function () {
            sc.classList.add('is-out', 'is-full');
            s.anims.push(gjAnim(sc, [{ transform: inT, opacity: 0 }, { transform: inT, opacity: 1, offset: .2 }, { transform: outT, opacity: 1 }], a1, 'cubic-bezier(.2,.7,.3,1)'));
          }, t0);
          later(p, function () { s.anims.push(gjAnim(sc, [{ transform: outT }, { transform: over }], a2)); }, t0 + a1);
          later(p, function () { s.anims.push(gjAnim(sc, [{ transform: over }, { transform: tip }], a3)); }, t0 + a1 + a2);
          var flowAt = t0 + a1 + a2 + Math.round(a3 * .55);
          later(p, function () { sc.classList.remove('is-full'); stream(p, g.jx, g.J.y - 40, g.surf(S(p).k)); }, flowAt);
          later(p, function () {
            var st = $('[data-gj-stream]', p); if (st) st.classList.remove('is-on');
            s.anims.push(gjAnim(sc, [{ transform: tip }, { transform: over, offset: .3 }, { transform: outT, offset: .7 }, { transform: inT, opacity: 1, offset: .92 }, { transform: inT, opacity: 0 }], T(1000)));
            later(p, function () { sc.classList.remove('is-out'); }, T(1000));
            capOn(p, g, T(1050));
          }, flowAt + fillMs + T(140));
          return flowAt + T(240);
        }
        var dr = $('[data-gj-drop]', p); if (!dr) return t0;
        var dw = dr.offsetWidth || 24, dh = dr.offsetHeight || 12;
        var x0 = g.mx - dw / 2, y0 = g.my - dh / 2, xj = g.jx - dw / 2, yTop = Math.min(g.my, g.J.y) - 90, y1 = g.surf(S(p).k) - dh / 2;
        var popMs = T(900);
        later(p, function () {
          dr.classList.add('is-out');
          s.anims.push(gjAnim(dr, [
            { transform: 'translate(' + x0 + 'px,' + (y0 + 10) + 'px) rotate(0deg) scale(.6)', opacity: 0 },
            { transform: 'translate(' + x0 + 'px,' + (y0 - 30) + 'px) rotate(40deg) scale(1)', opacity: 1, offset: .2 },
            { transform: 'translate(' + ((x0 + xj) / 2) + 'px,' + yTop + 'px) rotate(260deg) scale(1)', opacity: 1, offset: .55 },
            { transform: 'translate(' + xj + 'px,' + (g.J.y - 10) + 'px) rotate(420deg) scale(1)', opacity: 1, offset: .82 },
            { transform: 'translate(' + xj + 'px,' + y1 + 'px) rotate(480deg) scale(.9)', opacity: 0 }], popMs, 'cubic-bezier(.35,.1,.45,1)'));
        }, t0);
        later(p, function () { dr.classList.remove('is-out'); splash(p, g, S(p).k); }, t0 + popMs);
        later(p, function () { capOn(p, g, 0); }, t0 + popMs + fillMs + T(200));
        return t0 + popMs - T(60);
      }
      function fill(p) {
        var s = S(p), n = slices(p).length; if (s.busy || !n || s.k >= n) return;
        s.busy = true; root.classList.add('has-played');
        p.classList.remove('is-burst', 'is-full'); p.classList.add('is-filling');
        var step = T(420), g = geometry(p), remaining = n - s.k, k0 = s.k;
        var wait = pourIn(p, g, step * remaining);
        for (var i = 1; i <= remaining; i++) {
          (function (k) { later(p, function () {
            setK(p, k);
            var st = $('[data-gj-stream]', p); if (st && st.classList.contains('is-on')) st.style.setProperty('--fall', Math.max(20, g.surf(k) - (g.J.y - 40)) + 'px');
          }, wait + step * (k - k0 - 1)); })(k0 + i);
        }
        later(p, function () {
          p.classList.remove('is-filling'); p.classList.add('is-full');
          if (!reduced) { p.classList.add('is-burst'); later(p, function () { p.classList.remove('is-burst'); }, 1100); }
          syncSwitch();
        }, wait + step * remaining + T(200));
        later(p, function () { s.busy = false; }, wait + step * remaining + T(1900));
      }
      function drain(p, instant) {
        var s = S(p); stopMotion(p); s.busy = false;
        var c = $('[data-gj-cap]', p); if (c) { if (c.getAnimations) c.getAnimations().forEach(function (a) { a.cancel(); }); c.style.zIndex = ''; }
        p.classList.remove('is-full', 'is-burst', 'is-filling');
        if (instant || reduced) { setK(p, 0); syncSwitch(); return; }
        var k = s.k;
        (function down() { if (k <= 0) { syncSwitch(); return; } k--; setK(p, k); later(p, down, 110); })();
      }
      panels.forEach(function (p) {
        var t = $('[data-gj-total]', p); if (t) t.textContent = '0';
        S(p);
        choose(p, $('[data-gj-pick].is-on', p) || $('[data-gj-pick]', p));
        on($('[data-gj-jar]', p), 'click', function () { var s = S(p); if (s.busy) return; if (s.k >= slices(p).length) drain(p); else fill(p); });
        $$('[data-gj-pick]', p).forEach(function (b) {
          on(b, 'click', function () {
            if (b.classList.contains('is-on') && S(p).k >= slices(p).length) return;
            drain(p, true); choose(p, b); later(p, function () { fill(p); }, T(250));
          });
        });
        $$('[data-gj-row]', p).forEach(function (r, i) {
          on(r, 'mouseenter', function () { var sl = slices(p)[i]; if (sl) sl.classList.add('is-hot'); });
          on(r, 'mouseleave', function () { var sl = slices(p)[i]; if (sl) sl.classList.remove('is-hot'); });
        });
        var add = $('[data-gj-add]', p);
        on(add, 'click', function () {
          var id = +add.getAttribute('data-id'); if (!id) return;
          if (theme.addItems) theme.addItems({ items: [{ id: id, quantity: 1 }] }, add);
        });
      });
      on(sw, 'click', function () {
        var p = active(), s = S(p);
        if (sw.getAttribute('aria-pressed') === 'true') { sw.setAttribute('aria-pressed', 'false'); drain(p); }
        else { sw.setAttribute('aria-pressed', 'true'); if (!s.busy) fill(p); }
      });
      function show(i, focus) {
        panels.forEach(function (p, j) { if (j !== i) { if (!p.hidden) drain(p, true); p.hidden = true; } });
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        var p = panels[i]; if (!p) return;
        p.hidden = false; p.classList.remove('is-enter'); void p.offsetWidth; p.classList.add('is-enter');
        drain(p, true);
        var t = $('[data-gj-total]', p); if (t) { t.textContent = '0'; gjCount(t, Math.round(food)); }
        if (focus && tabs[i]) tabs[i].focus();
        if (auto && seen) later(p, function () { fill(p); }, T(900));
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { show(i); });
        on(t, 'keydown', function (e) {
          var j = i;
          if (e.key === 'ArrowRight') j = (i + 1) % tabs.length; else if (e.key === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length; else return;
          e.preventDefault(); show(j, true);
        });
      });
      function reveal() {
        if (seen) return; seen = true; root.classList.add('is-seen');
        var p = active(); gjCount($('[data-gj-total]', p), Math.round(food));
        if (auto) later(p, function () { fill(p); }, T(1400));
      }
      if (!('IntersectionObserver' in window)) { reveal(); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { reveal(); io.disconnect(); } }); }, { threshold: .3 });
      io.observe(root);
    });
  }

  // init: initReelSwitch
  /* ---------- Reels switch: move between two groups of reels (our team / your homes) ---------- */
  function initReelSwitch() {
    $$('[data-reel-switch]').forEach(function (sec) {
      if (sec._rs) return; sec._rs = true;
      var tabs = $$('[data-reel-tab]', sec), thumb = $('.reels__switch-thumb', sec);
      function place() {
        var t = tabs.filter(function (x) { return x.getAttribute('aria-selected') === 'true'; })[0];
        if (!t || !thumb) return;
        thumb.style.setProperty('--thumb-x', t.offsetLeft + 'px'); thumb.style.setProperty('--thumb-w', t.offsetWidth + 'px');
      }
      function show(g, focus) {
        tabs.forEach(function (t) { var on = t.getAttribute('data-reel-tab') === g; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
        $$('[data-reel-copy], [data-reel-pane]', sec).forEach(function (el) {
          var on = (el.getAttribute('data-reel-copy') || el.getAttribute('data-reel-pane')) === g, was = !el.hidden;
          if (!on) { $$('video', el).forEach(function (v) { try { v.pause(); } catch (e) {} }); $$('.reel.is-playing', el).forEach(function (r) { r.classList.remove('is-playing'); }); }
          el.hidden = !on;
          if (on && !was && !reduced) { el.classList.remove('is-entering'); void el.offsetWidth; el.classList.add('is-entering'); setTimeout(function () { el.classList.remove('is-entering'); }, 1200); }
          if (on) $$('[data-rail]', el).forEach(function (r) { r.scrollLeft = 0; r.dispatchEvent(new Event('scroll')); });
        });
        sec.setAttribute('data-reel-switch', g); place();
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { show(t.getAttribute('data-reel-tab')); });
        on(t, 'keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return; e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length]; show(n.getAttribute('data-reel-tab'), true);
        });
      });
      // theme editor: selecting a reel shows its group
      on(sec, 'shopify:block:select', function (e) { var p = e.target.closest('[data-reel-pane]'); if (p && p.hidden) show(p.getAttribute('data-reel-pane')); });
      window.addEventListener('resize', place);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
      place();
    });
  }

  // init: initFamilyKit
  /* ---------- Family kit: tap formulas per life stage, they drop into one kit, add all in one tap ---------- */
  function initFamilyKit() {
    $$('[data-fk]').forEach(function (fk) {
      if (fk._fk) return; fk._fk = true;
      var opts = $$('[data-fk-opt]', fk), shelf = $('[data-fk-shelf]', fk), count = $('[data-fk-count]', fk), total = $('[data-fk-total]', fk), add = $('[data-fk-add]', fk);
      var fmt = theme.formatMoney || function (c) { return '₹' + Math.round(c / 100); }, first = true;
      function picked() { return opts.filter(function (o) { return o.getAttribute('aria-pressed') === 'true'; }); }
      function words(n) { return n === 1 ? fk.getAttribute('data-one') : (fk.getAttribute('data-other') || '[n]').replace('[n]', n); }
      function fly(o) {
        if (reduced || first) return;
        var card = o.closest('[data-fk-card]'), src = card && $('[data-fk-pack="' + o.getAttribute('data-id') + '"] img', card), slot = $('[data-fk-thumb="' + o.getAttribute('data-id') + '"] img', shelf);
        if (!src || !slot || !src.animate) return;
        var a = src.getBoundingClientRect(), b = slot.getBoundingClientRect(); if (!a.width || !b.width) return;
        var c = src.cloneNode(); c.className = 'fk__fly'; c.removeAttribute('srcset'); c.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;height:' + a.height + 'px';
        document.body.appendChild(c); slot.style.opacity = '0';
        var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2), s = b.height / a.height;
        var an = c.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 80) + 'px) scale(' + (1 + s) / 2 + ') rotate(-8deg)', opacity: 1, offset: .5 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: .9 }],
          { duration: 700, easing: 'cubic-bezier(.5,0,.3,1)' });
        an.onfinish = function () { c.remove(); slot.style.opacity = ''; };
      }
      function render(changed) {
        var list = picked(), sum = 0, ids = list.map(function (o) { return o.getAttribute('data-id'); });
        $$('[data-fk-thumb]', shelf).forEach(function (t) {
          if (ids.indexOf(t.getAttribute('data-fk-thumb')) < 0 && !t.classList.contains('is-out')) { t.classList.add('is-out'); setTimeout(function () { t.remove(); }, reduced ? 0 : 300); }
        });
        list.forEach(function (o) {
          sum += parseInt(o.getAttribute('data-price'), 10) || 0;
          var id = o.getAttribute('data-id');
          if (!$('[data-fk-thumb="' + id + '"]', shelf)) {
            var t = document.createElement('span'); t.className = 'fk__thumb'; t.setAttribute('data-fk-thumb', id); t.style.cssText = o.getAttribute('style') || '';
            var src = o.getAttribute('data-img'); if (src) { var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy'; t.appendChild(im); }
            shelf.appendChild(t);
          }
        });
        shelf.classList.toggle('has-items', list.length > 0);
        var names = list.map(function (o) { return o.getAttribute('data-who') + ': ' + (o.getAttribute('data-label') || o.getAttribute('data-title')); });
        if (count) { count.textContent = list.length ? words(list.length) + ' · ' + names.join(', ') : fk.getAttribute('data-empty'); count.title = names.join('\n'); }
        if (total) { total.textContent = fmt(sum); if (!first) { var tw = total.parentNode; tw.classList.remove('is-bump'); void tw.offsetWidth; tw.classList.add('is-bump'); } }
        if (add) { add.disabled = !list.length; add.classList.remove('is-ready'); if (list.length && !first) { void add.offsetWidth; add.classList.add('is-ready'); } }
        $$('[data-fk-card]', fk).forEach(function (card) {
          var on = $$('[data-fk-opt][aria-pressed="true"]', card);
          card.classList.toggle('is-on', on.length > 0);
          var onIds = on.map(function (o) { return o.getAttribute('data-id'); });
          $$('[data-fk-pack]', card).forEach(function (p) { p.classList.toggle('is-on', onIds.indexOf(p.getAttribute('data-fk-pack')) > -1); });
        });
        if (changed && changed.getAttribute('aria-pressed') === 'true') fly(changed);
        first = false;
      }
      opts.forEach(function (o) {
        on(o, 'click', function () { o.setAttribute('aria-pressed', o.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); render(o); });
      });
      on(add, 'click', function () {
        var items = picked().map(function (o) { return { id: Number(o.getAttribute('data-id')), quantity: 1 }; }).filter(function (item) { return Number.isSafeInteger(item.id) && item.id > 0; });
        if (items.length && theme.addItems) theme.addItems({ items: items }, add);
      });
      render();
      /* rotating reviews */
      var revs = $$('[data-fk-review]', fk), r = 0, rt = null, hold = false, secs = (parseInt(fk.getAttribute('data-rotate'), 10) || 6) * 1000;
      function next() {
        if (hold || revs.length < 2) return;
        revs[r].classList.remove('is-on'); revs[r].setAttribute('aria-hidden', 'true');
        r = (r + 1) % revs.length; revs[r].classList.add('is-on'); revs[r].removeAttribute('aria-hidden');
      }
      if (revs.length > 1 && !reduced) {
        rt = setInterval(next, secs);
        var proof = $('[data-fk-proof]', fk);
        on(proof, 'mouseenter', function () { hold = true; }); on(proof, 'mouseleave', function () { hold = false; });
      }
    });
  }

  // init: initReviewSpotlight
  /* ---------- Review spotlight: a deck of real reviews that moves on by itself ---------- */
  function initReviewSpotlight() {
    $$('[data-rsx]').forEach(function (rx) {
      if (rx._rsx) return; rx._rsx = true;
      var cards = $$('[data-rsx-card]', rx), tabs = $$('[data-rsx-tab]', rx), now = $('[data-rsx-now]', rx), n = cards.length, cur = 0, timer = null, hold = false, seen = true;
      var tilt = parseFloat(getComputedStyle(rx).getPropertyValue('--rsx-tilt')) || 0, delay = (parseInt(rx.getAttribute('data-delay'), 10) || 7) * 1000;
      var auto = rx.getAttribute('data-autoplay') === 'true' && !reduced && n > 1;
      function lay() {
        cards.forEach(function (c, i) {
          var d = (i - cur + n) % n;
          c.style.setProperty('--dd', d); c.style.setProperty('--rot', d === 0 ? 0 : (d % 2 ? tilt : -tilt));
          c.classList.toggle('is-front', d === 0);
          if (d === 0) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
        });
        tabs.forEach(function (t, i) { t.setAttribute('aria-selected', i === cur ? 'true' : 'false'); t.tabIndex = i === cur ? 0 : -1; });
        if (now) now.textContent = cur + 1;
      }
      function go(i, dir) {
        if (n < 2) return;
        var old = cards[cur]; i = (i + n) % n; if (i === cur) { arm(); return; }
        if (dir > 0 && old.animate && !reduced) {
          old.animate([{ transform: getComputedStyle(old).transform, opacity: 1 }, { transform: 'translate(-70%, -6%) rotate(-14deg) scale(.96)', opacity: 0 }], { duration: 480, easing: 'cubic-bezier(.5,0,.75,0)' });
        }
        cur = i; lay(); arm();
      }
      function arm() {
        clearTimeout(timer); rx.classList.remove('is-auto');
        if (!auto || hold || !seen) return;
        void rx.offsetWidth; rx.classList.add('is-auto');
        timer = setTimeout(function () { go(cur + 1, 1); }, delay);
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { go(i, i > cur ? 1 : -1); });
        on(t, 'keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, 1); tabs[cur].focus(); }
          else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, -1); tabs[cur].focus(); }
        });
      });
      on($('[data-rsx-next]', rx), 'click', function () { go(cur + 1, 1); });
      on($('[data-rsx-prev]', rx), 'click', function () { go(cur - 1, -1); });
      var deck = $('[data-rsx-deck]', rx), sx = null;
      on(deck, 'pointerdown', function (e) { sx = e.clientX; });
      on(deck, 'pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); });
      on(deck, 'mouseenter', function () { hold = true; arm(); });
      on(deck, 'mouseleave', function () { hold = false; arm(); });
      on(rx, 'focusin', function () { hold = true; arm(); });
      on(rx, 'focusout', function () { hold = false; arm(); });
      on(rx, 'shopify:block:select', function (e) { var i = cards.indexOf(e.target.closest('[data-rsx-card]')); if (i > -1) { auto = false; cur = i; lay(); arm(); } });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; arm(); }, { threshold: .3 }).observe(rx);
      lay(); arm();
    });
  }

  // init: initClinicalIngredients
  /* ---------- Clinical ingredients: tap a partner (or let it move on), the seal and facts change ---------- */
  function initClinicalIngredients() {
    $$('[data-ci]').forEach(function (ci) {
      if (ci._ci) return; ci._ci = true;
      var tabs = $$('[data-ci-tab]', ci), panels = $$('[data-ci-panel]', ci), stage = $('.ci__stage', ci), now = $('[data-ci-now]', ci);
      var n = panels.length, cur = 0, timer = null, hold = false, seen = false, delay = (parseInt(ci.getAttribute('data-delay'), 10) || 6) * 1000;
      var auto = ci.getAttribute('data-autoplay') === 'true' && !reduced && n > 1;
      function colour(i) { var c = panels[i] && getComputedStyle(panels[i]).getPropertyValue('--pc').trim(); if (c && stage) stage.style.setProperty('--pcs', c); }
      function show(i, focus) {
        i = (i + n) % n;
        panels.forEach(function (p, j) {
          var on = j === i; p.hidden = !on; p.classList.toggle('is-on', on);
          if (on && j !== cur && !reduced) { p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); setTimeout(function () { p.classList.remove('is-entering'); }, 1100); }
        });
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; if (j === i && focus) t.focus(); });
        cur = i; colour(i); if (now) now.textContent = i + 1; arm();
      }
      function arm() {
        clearTimeout(timer); ci.classList.remove('is-auto');
        if (!auto || hold || !seen) return;
        void ci.offsetWidth; ci.classList.add('is-auto');
        timer = setTimeout(function () { show(cur + 1); }, delay);
      }
      tabs.forEach(function (t, i) {
        on(t, 'click', function () { show(i); });
        on(t, 'keydown', function (e) {
          var k = e.key; if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'ArrowDown' && k !== 'ArrowUp') return;
          e.preventDefault(); show(i + (k === 'ArrowRight' || k === 'ArrowDown' ? 1 : -1), true);
        });
        if (!reduced && window.matchMedia('(hover: hover)').matches) {
          on(t, 'mousemove', function (e) { var r = t.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; t.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg'); t.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg'); });
          on(t, 'mouseleave', function () { t.style.setProperty('--ry', '0deg'); t.style.setProperty('--rx', '0deg'); });
        }
      });
      on($('[data-ci-next]', ci), 'click', function () { show(cur + 1); });
      on($('[data-ci-prev]', ci), 'click', function () { show(cur - 1); });
      on(ci, 'mouseenter', function () { hold = true; arm(); });
      on(ci, 'mouseleave', function () { hold = false; arm(); });
      on(ci, 'focusin', function () { hold = true; arm(); });
      on(ci, 'focusout', function () { hold = false; arm(); });
      var sx = null;
      on(stage, 'pointerdown', function (e) { sx = e.clientX; });
      on(stage, 'pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); });
      on(ci, 'shopify:block:select', function (e) { var i = tabs.indexOf(e.target.closest('[data-ci-tab]')); if (i < 0) i = panels.indexOf(e.target.closest('[data-ci-panel]')); if (i > -1) { auto = false; show(i); } });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { if (es[0].isIntersecting) ci.classList.add('is-in'); seen = es[0].isIntersecting; arm(); }, { threshold: .3 }).observe(ci);
      else { ci.classList.add('is-in'); seen = true; }
      colour(0); arm();
    });
  }

  // init: initWhy
  /* ---------- Why U-VITA (v16, look inside): flip between a regular product (grey separate bottles) and U-VITA
     (the ingredients light up and stream into the pack, the list ticks off); tap a bubble or a row for its note ---------- */
  function initWhy() {
    $$('[data-why16]').forEach(function (w) {
      if (w._why) return; w._why = true;
      var btns = $$('[data-why16-mode]', w), pill = $('.why16__switch-pill', w), num = $('[data-why16-count]', w);
      var rows = $$('[data-why16-row]', w), bubs = $$('[data-why16-b]', w), touched = false, sel = -1;
      var to = num ? parseInt(num.getAttribute('data-to'), 10) || 0 : 0;
      function placePill() {
        var on = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
        if (!pill || !on) return;
        pill.style.width = on.offsetWidth + 'px'; pill.style.transform = 'translateX(' + on.offsetLeft + 'px)';
      }
      function count() {
        if (!num) return;
        if (reduced) { num.textContent = to; return; }
        var t0 = null, dur = 400 + to * 160;
        (function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); num.textContent = Math.round(to * k); if (k < 1) requestAnimationFrame(step); })(performance.now());
      }
      function mode(m) {
        if (w.getAttribute('data-mode') === m) return;
        w.setAttribute('data-mode', m);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-why16-mode') === m ? 'true' : 'false'); });
        placePill();
        if (m === 'uvita') { count(); w.classList.remove('is-burst'); void w.offsetWidth; w.classList.add('is-burst'); }
      }
      function select(i) {
        sel = i;
        rows.forEach(function (r, k) { r.classList.toggle('is-hot', k === i); });
        bubs.forEach(function (b, k) { b.classList.toggle('is-hot', k === i); b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        $$('.why16__beam', w).forEach(function (b, k) { b.classList.toggle('is-hot', k === i); });
        w.classList.toggle('has-sel', i >= 0);
        var r = rows[i];
        if (r && r.getBoundingClientRect) { var rc = r.getBoundingClientRect(); if (rc.top > innerHeight - 40 || rc.bottom < 40) r.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' }); }
      }
      btns.forEach(function (b) { on(b, 'click', function () { touched = true; mode(b.getAttribute('data-why16-mode')); }); });
      bubs.forEach(function (b, k) { on(b, 'click', function () { touched = true; select(sel === k ? -1 : k); }); });
      rows.forEach(function (r, k) {
        on(r, 'mouseenter', function () { bubs[k] && bubs[k].classList.add('is-near'); });
        on(r, 'mouseleave', function () { bubs[k] && bubs[k].classList.remove('is-near'); });
        on(r, 'click', function () { touched = true; select(sel === k ? -1 : k); });
      });
      on(window, 'resize', placePill);
      placePill();
      if (reduced || !('IntersectionObserver' in window) || w.getAttribute('data-autoplay') !== 'true') return;
      mode('regular'); w.classList.add('is-pre');
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect(); w.classList.remove('is-pre');
        setTimeout(function () { if (!touched) mode('uvita'); }, 1500);
      }, { threshold: 0.35 });
      io.observe(w);
    });
  }

  // init: initWeeks
  /* ---------- Week by week (v16): an illustrated person moves through the milestones. The rig (UVPerson) gives the
     pose, uvPaintPerson draws it; each week has a pose and a small scene. Plays once when it comes into view; tap the
     person for a hop, the eyes follow the pointer. ---------- */
  /* U-VITA week-by-week person: a small 2D rig (front view). Pure functions, shared by the theme script
     (assets/theme.js, initWeeks) and by tools/v16_sections.py (which runs it in Node to bake the still pose
     into the Liquid snippet, so the person shows even before the script runs).
     Angles are in degrees; 0 points straight down, 90 points away from the body, 180 points up, negative
     values point across the body. Lengths are in SVG units (viewBox 0 0 400 420). */
  var UVPerson = (function () {
    var BUILDS = {
      adult: { hipY: 262, torso: 80, neck: 9, head: 31, sw: 20, hw: 13, ua: 42, fa: 38, th: 50, sh: 48, limb: 17, leg: 21, hem: 20, scale: 1 },
      teen:  { hipY: 266, torso: 74, neck: 8, head: 32, sw: 18, hw: 12, ua: 39, fa: 35, th: 47, sh: 45, limb: 16, leg: 19, hem: 6, scale: 1 },
      kid:   { hipY: 290, torso: 56, neck: 6, head: 36, sw: 15, hw: 11, ua: 29, fa: 27, th: 34, sh: 33, limb: 15, leg: 17, hem: 0, scale: 1 }
    };
    // poses: y = hip offset, lean = torso, hd = head tilt, a = [upper, lower] arm angles (r = viewer's right, l = left), g = legs
    var POSES = {
      stand:   { y: 0, lean: 0, hd: 0, ar: [9, 5], al: [9, 5], gr: [3, 1], gl: [3, 1], face: 'smile' },
      stretch: { y: -7, lean: 0, hd: -4, ar: [160, 172], al: [160, 172], gr: [4, 2], gl: [4, 2], face: 'happy' },
      glow:    { y: 0, lean: 2, hd: 9, ar: [150, -84], al: [30, -28], gr: [4, 2], gl: [2, 0], face: 'happy' },
      lotus:   { y: 74, lean: 0, hd: 0, ar: [24, 52], al: [24, 52], gr: [80, -84], gl: [80, -84], face: 'calm' },
      power:   { y: 0, lean: 0, hd: -2, ar: [42, -34], al: [42, -34], gr: [9, 4], gl: [9, 4], face: 'smile' },
      flex:    { y: 0, lean: 0, hd: 0, ar: [96, 176], al: [96, 176], gr: [9, 4], gl: [9, 4], face: 'big' },
      think:   { y: 0, lean: -2, hd: -7, ar: [-8, -172], al: [30, -62], gr: [3, 1], gl: [5, 2], face: 'up' },
      look:    { y: 0, lean: 0, hd: 3, ar: [146, -100], al: [9, 5], gr: [5, 2], gl: [5, 2], face: 'smile' },
      drink:   { y: 0, lean: 0, hd: 3, ar: [14, -150], al: [12, 6], gr: [3, 1], gl: [3, 1], face: 'happy' },
      jump:    { y: -6, lean: 0, hd: -3, ar: [132, 148], al: [132, 148], gr: [6, 3], gl: [6, 3], face: 'big' },
      wave:    { y: 0, lean: -2, hd: 4, ar: [150, 176], al: [9, 5], gr: [4, 2], gl: [4, 2], face: 'big' }
    };
    var ICON_POSE = {
      energy: 'stretch', stamina: 'stretch', vitality: 'stretch',
      radiance: 'glow', sparkle: 'glow', smile: 'glow', vision: 'look',
      balance: 'lotus', lotus: 'lotus', moon: 'lotus', 'hormone-harmony': 'lotus', 'hormone-support': 'lotus',
      shield: 'power', immunity: 'power', drop: 'power', gut: 'power', layers: 'power', heart: 'power',
      strength: 'flex', bone: 'flex', recovery: 'flex', mobility: 'flex',
      run: 'jump', growth: 'jump', longevity: 'wave', independence: 'wave',
      brain: 'think', focus: 'think', memory: 'think',
      glass: 'drink', tablet: 'drink', shake: 'drink', gummy: 'drink'
    };
    var ICON_FX = {
      energy: 'rays', stamina: 'rays', vitality: 'rays', radiance: 'sparkle', sparkle: 'sparkle', smile: 'sparkle', vision: 'sparkle',
      balance: 'rings', lotus: 'rings', 'hormone-harmony': 'rings', 'hormone-support': 'rings', moon: 'night',
      shield: 'shield', immunity: 'shield', drop: 'hearts', gut: 'hearts', layers: 'hearts', heart: 'hearts',
      strength: 'pulse', bone: 'pulse', recovery: 'pulse', mobility: 'pulse', run: 'confetti', growth: 'confetti',
      longevity: 'hearts', independence: 'hearts', brain: 'bulb', focus: 'bulb', memory: 'bulb',
      glass: 'hearts', tablet: 'hearts', shake: 'hearts', gummy: 'hearts'
    };
    function rad(d) { return d * Math.PI / 180; }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function mix(p, q, t) {
      var o = {};
      for (var k in p) {
        if (k === 'face') o.face = t < .5 ? p.face : q.face;
        else if (p[k] && p[k].length) o[k] = [lerp(p[k][0], q[k][0], t), lerp(p[k][1], q[k][1], t)];
        else o[k] = lerp(p[k], q[k], t);
      }
      return o;
    }
    function clone(p) { return mix(p, p, 0); }
    // live motion on top of a pose (t in seconds)
    function loop(name, p, t, build) {
      var o = clone(p), s = Math.sin, b = s(t * Math.PI * 2 / 4);   // a 4 s breath
      o.breath = b;
      o.y += b * 1.4;
      if (name === 'stretch') { o.lean += s(t * 1.3) * 3; o.ar[0] += s(t * 1.3) * 5; o.al[0] -= s(t * 1.3) * 5; }
      if (name === 'glow') { o.hd += s(t * 1.6) * 3.5; }
      if (name === 'lotus') { o.y += -5 + s(t * Math.PI * 2 / 4) * 4; o.ar[0] += b * 4; o.al[0] += b * 4; }
      if (name === 'power') { o.hd += s(t * 1.1) * 2; }
      if (name === 'flex') { var f = s(t * 4.2); o.ar[1] += f * 12; o.al[1] += f * 12; o.y += Math.abs(f) * -2; }
      if (name === 'think') { o.hd += s(t * 1.2) * 3; }
      if (name === 'look') { o.hd += s(t * .9) * 5; o.lean += s(t * .9) * 2; }
      if (name === 'drink') { var d = (s(t * 1.6) + 1) / 2; o.ar[1] = lerp(-150, -170, d); o.ar[0] = lerp(14, 40, d); o.hd = lerp(3, -6, d); }
      if (name === 'jump') {
        var ph = (t % .9) / .9, air = Math.sin(ph * Math.PI);
        o.y += -42 * air;
        o.gr[0] = 4 + 20 * air; o.gl[0] = 4 + 20 * air; o.gr[1] = 2 + 24 * air; o.gl[1] = 2 + 24 * air;
        o.ar[0] += 10 * air; o.al[0] += 10 * air;
        o.squash = air < .12 ? (.12 - air) * .5 : 0;
      }
      if (name === 'wave') { o.ar[1] = 176 + s(t * 7) * 24; o.ar[0] = 150 + s(t * 7) * 6; o.lean += s(t * 1.2) * 1.5; }
      return o;
    }
    function pt(x, y) { return { x: x, y: y }; }
    function limb(o, side, len, ang) {
      var a = rad(ang * side);
      return pt(o.x + Math.sin(a) * len, o.y + Math.cos(a) * len);
    }
    function f1(n) { return Math.round(n * 10) / 10; }
    function seg(a, b, c) { return 'M' + f1(a.x) + ' ' + f1(a.y) + 'L' + f1(b.x) + ' ' + f1(b.y) + (c ? 'L' + f1(c.x) + ' ' + f1(c.y) : ''); }
    // all the drawable geometry for one frame
    function geometry(p, bname, opts) {
      var B = BUILDS[bname] || BUILDS.adult, cx = 200; opts = opts || {};
      var hip = pt(cx, B.hipY + p.y), L = rad(p.lean), sq = p.squash || 0;
      var tl = B.torso * (1 - sq) * (1 + (p.breath || 0) * .01);
      var neck = pt(hip.x + Math.sin(L) * tl, hip.y - Math.cos(L) * tl);
      var px = Math.cos(L), py = Math.sin(L);   // across the body
      var sR = pt(neck.x + px * B.sw, neck.y + py * B.sw + 6), sL = pt(neck.x - px * B.sw, neck.y - py * B.sw + 6);
      var hR = pt(hip.x + px * B.hw, hip.y + py * B.hw), hL = pt(hip.x - px * B.hw, hip.y - py * B.hw);
      var g = {};
      // arms
      var eR = limb(sR, 1, B.ua, p.ar[0]), wR = limb(eR, 1, B.fa, p.ar[1]);
      var eL = limb(sL, -1, B.ua, p.al[0]), wL = limb(eL, -1, B.fa, p.al[1]);
      // legs (knees and feet)
      var kR = limb(hR, 1, B.th, p.gr[0]), fR = limb(kR, 1, B.sh, p.gr[1]);
      var kL = limb(hL, -1, B.th, p.gl[0]), fL = limb(kL, -1, B.sh, p.gl[1]);
      g.armR = seg(sR, eR, wR); g.armL = seg(sL, eL, wL);
      if (opts.sleeve === 'long') {
        g.sleeveR = seg(sR, eR, pt(lerp(eR.x, wR.x, .5), lerp(eR.y, wR.y, .5))); g.sleeveL = seg(sL, eL, pt(lerp(eL.x, wL.x, .5), lerp(eL.y, wL.y, .5)));
      } else {
        g.sleeveR = seg(sR, pt(lerp(sR.x, eR.x, .6), lerp(sR.y, eR.y, .6))); g.sleeveL = seg(sL, pt(lerp(sL.x, eL.x, .6), lerp(sL.y, eL.y, .6)));
      }
      g.legR = seg(hR, kR, fR); g.legL = seg(hL, kL, fL);
      g.handR = wR; g.handL = wL; g.footR = fR; g.footL = fL;
      // torso: shoulders, waist and hem (a kurta for adults, a tee for teens and kids)
      var hem = opts.hem != null ? +opts.hem : B.hem, wide = B.hw + (hem > 10 ? 13 : 4);
      var bR = pt(hip.x + px * wide - py * hem, hip.y + py * wide + px * hem), bL = pt(hip.x - px * wide - py * hem, hip.y - py * wide + px * hem);
      // waist a little narrower than the shoulders, the hem flaring out for a kurta
      var wy = .62, wR = pt(lerp(sR.x, hR.x, wy) + px * 1, lerp(sR.y, hR.y, wy)), wL = pt(lerp(sL.x, hL.x, wy) - px * 1, lerp(sL.y, hL.y, wy));
      function P2(q) { return f1(q.x) + ' ' + f1(q.y); }
      g.torso = 'M' + P2(pt(sL.x, sL.y - 2)) + 'L' + P2(pt(sR.x, sR.y - 2)) + 'Q' + P2(pt(sR.x + px * 2, lerp(sR.y, wR.y, .5))) + ' ' + P2(wR) + 'L' + P2(bR) + 'L' + P2(bL) + 'L' + P2(wL) + 'Q' + P2(pt(sL.x - px * 2, lerp(sL.y, wL.y, .5))) + ' ' + P2(pt(sL.x, sL.y - 2)) + 'Z';
      g.collar = 'M' + P2(pt(neck.x - px * 9, neck.y + 4)) + 'Q' + P2(pt(neck.x, neck.y + 14)) + ' ' + P2(pt(neck.x + px * 9, neck.y + 4));
      g.neck = seg(neck, pt(neck.x, neck.y - B.neck));
      var hc = pt(neck.x + Math.sin(L) * (B.neck + B.head * .82), neck.y - Math.cos(L) * (B.neck + B.head * .82));
      g.head = 'translate(' + f1(hc.x) + ' ' + f1(hc.y) + ') rotate(' + f1(p.hd + p.lean) + ') scale(' + f1(B.head / 31 * 100) / 100 + ')';
      g.shadow = { rx: f1(56 - Math.max(0, -p.y) * .5), op: Math.max(.25, 1 - Math.max(0, -p.y) / 60) };
      g.hip = hip; g.neckPt = neck; g.headPt = hc; g.face = p.face;
      g.chest = pt(lerp(neck.x, hip.x, .35), lerp(neck.y, hip.y, .35));
      return g;
    }
    return { BUILDS: BUILDS, POSES: POSES, ICON_POSE: ICON_POSE, ICON_FX: ICON_FX, mix: mix, loop: loop, geometry: geometry };
  })();

  /* paints one frame of the week-by-week person (geometry from UVPerson.geometry) */
  function uvPaintPerson(svg, g, parts) {
    function P(n) { return parts[n] || (parts[n] = svg.querySelector('[data-p="' + n + '"]')); }
    ['armL', 'armR', 'legL', 'legR', 'sleeveL', 'sleeveR', 'torso', 'neck', 'collar'].forEach(function (n) { var el = P(n); if (el) el.setAttribute('d', g[n]); });
    ['handL', 'handR'].forEach(function (n) { var el = P(n); if (el) { el.setAttribute('cx', g[n].x.toFixed(1)); el.setAttribute('cy', g[n].y.toFixed(1)); } });
    ['footL', 'footR'].forEach(function (n) { var el = P(n); if (el) { el.setAttribute('cx', (g[n].x + (n === 'footR' ? 3 : -3)).toFixed(1)); el.setAttribute('cy', (g[n].y + 3).toFixed(1)); } });
    var h = P('head'), hb = P('headback'); if (h) h.setAttribute('transform', g.head); if (hb) hb.setAttribute('transform', g.head);
    var pr = P('prop'); if (pr) pr.setAttribute('transform', 'translate(' + g.handR.x.toFixed(1) + ' ' + g.handR.y.toFixed(1) + ')');
    var sh = P('shadow'); if (sh) { sh.setAttribute('rx', g.shadow.rx); sh.style.opacity = g.shadow.op; }
    var hp = 'translate(' + g.headPt.x.toFixed(1) + ' ' + g.headPt.y.toFixed(1) + ')';
    ['sparkle', 'bulb'].forEach(function (n) { var el = P(n); if (el) el.setAttribute('transform', hp); });
    var r = P('rings'); if (r) r.setAttribute('transform', 'translate(' + g.chest.x.toFixed(1) + ' ' + g.chest.y.toFixed(1) + ')');
    var he = P('hearts'); if (he) he.setAttribute('transform', 'translate(' + g.chest.x.toFixed(1) + ' ' + (g.chest.y - 20).toFixed(1) + ')');
    var pu = P('pulse'); if (pu) pu.setAttribute('transform', 'translate(' + g.handR.x.toFixed(1) + ' ' + g.handR.y.toFixed(1) + ')');
    if (svg.getAttribute('data-face') !== g.face) svg.setAttribute('data-face', g.face);
  }

  function initWeeks() {
    $$('[data-wk16]').forEach(function (w) {
      if (w._wk) return; w._wk = true;
      var stage = $('[data-wk16-stage]', w), svg = $('.wkp__svg', w), cards = $$('[data-wk16-card]', w), stops = $$('[data-wk16-stop]', w);
      var fill = $('[data-wk16-fill]', w), dayEl = $('[data-wk16-day]', w), numEl = $('[data-wk16-num]', w), say = $('[data-wk16-say]', w), bubble = $('[data-wk16-bubble]', w);
      var person = $('[data-wk16-person]', w), play = $('[data-wk16-play]', w), playL = $('[data-wk16-play-l]', w), hint = $('[data-wk16-hint]', w), eyes = svg && $('[data-p="eyes"]', svg);
      if (!svg || !cards.length) return;
      var build = svg.getAttribute('data-build'), opts = { hem: svg.getAttribute('data-hem'), sleeve: svg.getAttribute('data-sleeve') }, parts = {};
      var secs = (parseFloat(w.getAttribute('data-secs')) || 4) * 1000, n = cards.length;
      var list = cards.map(function (c) { var ic = c.getAttribute('data-icon'); return { pose: UVPerson.ICON_POSE[ic] || 'power', fx: UVPerson.ICON_FX[ic] || 'sparkle', week: +c.getAttribute('data-week'), title: c.getAttribute('data-title') }; });
      var cur = 0, from = 'stand', fromP = UVPerson.POSES.stand, t0 = 0, dur = 900, raf = 0, visible = false, timer = 0, playing = false, hop = -1, dayNow = list[0].week * 7;
      w.classList.add('is-live');
      function ease(k) { return k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; }
      function frame(now) {
        var t = now / 1000, L = list[cur], k = Math.min(1, (now - t0) / dur), p;
        var pTo = reduced ? UVPerson.POSES[L.pose] : UVPerson.loop(L.pose, UVPerson.POSES[L.pose], t, build);
        if (k < 1) { var pFrom = reduced ? fromP : UVPerson.loop(from, fromP, t, build); p = UVPerson.mix(pFrom, pTo, ease(k)); } else p = pTo;
        if (hop >= 0) {
          var hk = (now - hop) / 650;
          if (hk >= 1) hop = -1; else { var air = Math.sin(hk * Math.PI); p = UVPerson.mix(p, p, 0); p.y -= 36 * air; p.face = 'big'; p.gr[1] -= 24 * air; p.gl[1] -= 24 * air; }
        }
        var g = UVPerson.geometry(p, build, opts);
        uvPaintPerson(svg, g, parts);
        if (bubble) {
          var W = stage.offsetWidth, H = stage.offsetHeight, sc = (person.offsetHeight || H) / 420, bw = bubble.offsetWidth, bh = bubble.offsetHeight;
          var bx = W / 2 + (g.headPt.x - 200) * sc + 30 * sc, by = person.offsetTop + g.headPt.y * sc - 34 * sc - bh;
          bubble.style.transform = 'translate(' + Math.round(Math.max(8, Math.min(W - bw - 8, bx))) + 'px,' + Math.round(Math.max(8, by)) + 'px)';
        }
        if (!reduced && visible) raf = requestAnimationFrame(frame);
      }
      function kick() { cancelAnimationFrame(raf); raf = requestAnimationFrame(frame); }
      function countDay(to) {
        if (!dayEl) return;
        var a = dayNow, s0 = performance.now(), ms = reduced ? 0 : 700;
        dayNow = to;
        (function st(t) { var k = ms ? Math.min(1, (t - s0) / ms) : 1; dayEl.textContent = Math.round(a + (to - a) * k); if (k < 1) requestAnimationFrame(st); })(s0);
      }
      function go(i, quiet) {
        i = Math.max(0, Math.min(n - 1, i));
        var L = list[i];
        if (i !== cur || quiet === 'first') {
          var prev = list[cur];
          from = prev.pose; fromP = UVPerson.POSES[prev.pose]; t0 = performance.now(); cur = i;
        }
        cards.forEach(function (c, k) { var a = k === i; c.classList.toggle('is-on', a); c.setAttribute('aria-hidden', a ? 'false' : 'true'); });
        stops.forEach(function (s, k) { s.setAttribute('aria-selected', k === i ? 'true' : 'false'); s.tabIndex = k === i ? 0 : -1; s.classList.toggle('is-past', k < i); });
        if (fill) fill.style.transform = 'scaleX(' + (n > 1 ? i / (n - 1) : 1) + ')';
        svg.setAttribute('data-fx', L.fx); svg.setAttribute('data-pose', L.pose);
        stage.setAttribute('data-fx', L.fx);
        if (numEl) { numEl.textContent = L.week; numEl.classList.remove('is-flip'); void numEl.offsetWidth; numEl.classList.add('is-flip'); }
        if (say) { say.textContent = L.title; bubble.classList.remove('is-pop'); void bubble.offsetWidth; bubble.classList.add('is-pop'); }
        countDay(L.week * 7);
        kick();
      }
      function setPlay(on) { playing = on; w.classList.toggle('is-playing', on); if (playL) playL.textContent = on ? w.getAttribute('data-pause') : w.getAttribute('data-play'); }
      function stop() { clearInterval(timer); setPlay(false); }
      function start(fromFirst) {
        clearInterval(timer); setPlay(true);
        if (fromFirst || cur >= n - 1) go(0); else go(cur + 1);
        timer = setInterval(function () { if (cur >= n - 1) { stop(); return; } go(cur + 1); }, secs);
      }
      stops.forEach(function (s, k) {
        on(s, 'click', function () { stop(); go(k); });
        on(s, 'keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault(); stop(); var j = Math.max(0, Math.min(n - 1, cur + (e.key === 'ArrowRight' ? 1 : -1))); go(j); stops[j].focus();
        });
      });
      if (play) on(play, 'click', function () { if (playing) stop(); else start(cur >= n - 1); });
      on($('[data-wk16-person]', w), 'click', function () {
        if (hint) hint.classList.add('is-gone');
        if (reduced) return;
        hop = performance.now(); stage.classList.remove('is-react'); void stage.offsetWidth; stage.classList.add('is-react'); kick();
      });
      on(w, 'pointermove', function (e) {
        if (!eyes) return;
        var r = svg.getBoundingClientRect(), hx = r.left + r.width / 2, hy = r.top + r.height * .35;
        var dx = e.clientX - hx, dy = e.clientY - hy, d = Math.sqrt(dx * dx + dy * dy) || 1, m = Math.min(1, d / 260);
        eyes.style.transform = 'translate(' + (dx / d * 2.4 * m).toFixed(2) + 'px,' + (dy / d * 2 * m).toFixed(2) + 'px)';
      });
      on(w, 'pointerleave', function () { if (eyes) eyes.style.transform = ''; });
      go(0, 'first');
      if (!('IntersectionObserver' in window)) { visible = true; kick(); return; }
      var seen = false;
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        if (visible) kick(); else cancelAnimationFrame(raf);
        if (visible && !seen && es[0].intersectionRatio >= .4) {
          seen = true;
          if (!reduced && w.getAttribute('data-autoplay') === 'true') setTimeout(function () { start(true); }, 600);
        }
      }, { threshold: [0, .4] }).observe(w);
    });
  }

  /* ==== v11 end ==== */

  /* ---------- Boot ---------- */
  function boot() {
    initReveal(); initCounters(); initInView(); initAnnouncement(); initHeader(); initMega(); initMobileMenu(); initHero();
    initRails(); initTabs(); initLadder(); initGap(); initRange(); initGallery(); initProductForms(); initStickyAtc(); initFinder(); initCollection(); initReadProgress(); initWishlist(); initKi(); initMotion(); initHx(); initFamilyLadder(); initReels(); initNeed(); initHabit(); initLab(); initAmbient(); initRoutine(); initNeedCheck(); /*v11*/ initHeroStage(); initGapJar(); initReelSwitch(); initFamilyKit(); initReviewSpotlight(); initClinicalIngredients(); initWhy(); initWeeks(); /*v11end*/ /*v10*/ initStory(); initTrust(); initHxFx(); initFlAuto(); /*v10end*/
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
